{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "blueprints": [
    {
      "key": "AFM_Shielded",
      "fdName": "AFM_Shielded",
      "moduleKeys": [
        "am"
      ],
      "moduleName": "Auto Field-Maintenance Unit",
      "name": "Shielded",
      "displayName": "Auto Field-Maintenance Unit — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Armour_Advanced",
      "fdName": "Armour_Advanced",
      "moduleKeys": [
        "bh"
      ],
      "moduleName": "Armour",
      "name": "Lightweight",
      "displayName": "Armour — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.03
            ],
            "hullboost": [
              -0.01,
              -0.01
            ],
            "kinres": [
              0,
              0.03
            ],
            "mass": [
              0,
              -0.15
            ],
            "thermres": [
              0,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-25%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.03,
              0.06
            ],
            "hullboost": [
              -0.02,
              -0.02
            ],
            "kinres": [
              0.03,
              0.06
            ],
            "mass": [
              -0.15,
              -0.25
            ],
            "thermres": [
              0.03,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.06,
              0.09
            ],
            "hullboost": [
              -0.03,
              -0.03
            ],
            "kinres": [
              0.06,
              0.09
            ],
            "mass": [
              -0.25,
              -0.35
            ],
            "thermres": [
              0.06,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.09,
              0.12
            ],
            "hullboost": [
              -0.04,
              -0.04
            ],
            "kinres": [
              0.09,
              0.12
            ],
            "mass": [
              -0.35,
              -0.45
            ],
            "thermres": [
              0.09,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "militarygradealloys",
              "name": "Military Grade Alloys",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.12,
              0.15
            ],
            "hullboost": [
              -0.05,
              -0.05
            ],
            "kinres": [
              0.12,
              0.15
            ],
            "mass": [
              -0.45,
              -0.55
            ],
            "thermres": [
              0.12,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Armour_Explosive",
      "fdName": "Armour_Explosive",
      "moduleKeys": [
        "bh"
      ],
      "moduleName": "Armour",
      "name": "Blast Resistant",
      "displayName": "Armour — Blast Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.12
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.12,
              0.19
            ],
            "kinres": [
              -0.06,
              -0.06
            ],
            "thermres": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.19,
              0.26
            ],
            "kinres": [
              -0.08,
              -0.08
            ],
            "thermres": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "mercury",
              "name": "Mercury",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.26,
              0.33
            ],
            "kinres": [
              -0.1,
              -0.1
            ],
            "thermres": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "ruthenium",
              "name": "Ruthenium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.33,
              0.4
            ],
            "kinres": [
              -0.12,
              -0.12
            ],
            "thermres": [
              -0.12,
              -0.12
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Armour_HeavyDuty",
      "fdName": "Armour_HeavyDuty",
      "moduleKeys": [
        "bh"
      ],
      "moduleName": "Armour",
      "name": "Heavy Duty",
      "displayName": "Armour — Heavy Duty",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+1%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.01
            ],
            "hullboost": [
              0,
              0.12
            ],
            "kinres": [
              0,
              0.01
            ],
            "mass": [
              0.1,
              0.1
            ],
            "thermres": [
              0,
              0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "+17%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.01,
              0.02
            ],
            "hullboost": [
              0.12,
              0.17
            ],
            "kinres": [
              0.01,
              0.02
            ],
            "mass": [
              0.15,
              0.15
            ],
            "thermres": [
              0.01,
              0.02
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "+22%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.02,
              0.03
            ],
            "hullboost": [
              0.17,
              0.22
            ],
            "kinres": [
              0.02,
              0.03
            ],
            "mass": [
              0.2,
              0.2
            ],
            "thermres": [
              0.02,
              0.03
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.03,
              0.04
            ],
            "hullboost": [
              0.22,
              0.27
            ],
            "kinres": [
              0.03,
              0.04
            ],
            "mass": [
              0.25,
              0.25
            ],
            "thermres": [
              0.03,
              0.04
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "All Resistances",
              "effect": "+5%",
              "isGood": true
            },
            {
              "property": "Hull Boost",
              "effect": "+32%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.04,
              0.05
            ],
            "hullboost": [
              0.27,
              0.32
            ],
            "kinres": [
              0.04,
              0.05
            ],
            "mass": [
              0.3,
              0.3
            ],
            "thermres": [
              0.04,
              0.05
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Armour_Kinetic",
      "fdName": "Armour_Kinetic",
      "moduleKeys": [
        "bh"
      ],
      "moduleName": "Armour",
      "name": "Kinetic Resistant",
      "displayName": "Armour — Kinetic Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "kinres": [
              0,
              0.12
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+19%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.06,
              -0.06
            ],
            "kinres": [
              0.12,
              0.19
            ],
            "thermres": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.08,
              -0.08
            ],
            "kinres": [
              0.19,
              0.26
            ],
            "thermres": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+33%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.1,
              -0.1
            ],
            "kinres": [
              0.26,
              0.33
            ],
            "thermres": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+40%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.12,
              -0.12
            ],
            "kinres": [
              0.33,
              0.4
            ],
            "thermres": [
              -0.12,
              -0.12
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Armour_Thermic",
      "fdName": "Armour_Thermic",
      "moduleKeys": [
        "bh"
      ],
      "moduleName": "Armour",
      "name": "Thermal Resistant",
      "displayName": "Armour — Thermal Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              0,
              0.12
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.06,
              -0.06
            ],
            "kinres": [
              -0.06,
              -0.06
            ],
            "thermres": [
              0.12,
              0.19
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.08,
              -0.08
            ],
            "kinres": [
              -0.08,
              -0.08
            ],
            "thermres": [
              0.19,
              0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.1,
              -0.1
            ],
            "kinres": [
              -0.1,
              -0.1
            ],
            "thermres": [
              0.26,
              0.33
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.12,
              -0.12
            ],
            "kinres": [
              -0.12,
              -0.12
            ],
            "thermres": [
              0.33,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "CollectionLimpet_LightWeight",
      "fdName": "CollectionLimpet_LightWeight",
      "moduleKeys": [
        "cc"
      ],
      "moduleName": "Collector Limpet Controller",
      "name": "Lightweight",
      "displayName": "Collector Limpet Controller — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "CollectionLimpet_Reinforced",
      "fdName": "CollectionLimpet_Reinforced",
      "moduleKeys": [
        "cc"
      ],
      "moduleName": "Collector Limpet Controller",
      "name": "Reinforced",
      "displayName": "Collector Limpet Controller — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "CollectionLimpet_Shielded",
      "fdName": "CollectionLimpet_Shielded",
      "moduleKeys": [
        "cc"
      ],
      "moduleName": "Collector Limpet Controller",
      "name": "Shielded",
      "displayName": "Collector Limpet Controller — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Engine_Dirty",
      "fdName": "Engine_Dirty",
      "moduleKeys": [
        "t"
      ],
      "moduleName": "Thrusters",
      "name": "Dirty Drive Tuning",
      "displayName": "Thrusters — Dirty Drive Tuning",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.03,
              -0.03
            ],
            "optmass": [
              -0.025,
              -0.025
            ],
            "optmul": [
              0,
              0.12
            ],
            "power": [
              0.04,
              0.04
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.06,
              -0.06
            ],
            "optmass": [
              -0.05,
              -0.05
            ],
            "optmul": [
              0.12,
              0.19
            ],
            "power": [
              0.06,
              0.06
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.09,
              -0.09
            ],
            "optmass": [
              -0.075,
              -0.075
            ],
            "optmul": [
              0.19,
              0.26
            ],
            "power": [
              0.08,
              0.08
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.12,
              -0.12
            ],
            "optmass": [
              -0.1,
              -0.1
            ],
            "optmul": [
              0.26,
              0.33
            ],
            "power": [
              0.1,
              0.1
            ],
            "thermload": [
              0.5,
              0.5
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "pharmaceuticalisolators",
              "name": "Pharmaceutical Isolators",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-13%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.15,
              -0.15
            ],
            "optmass": [
              -0.125,
              -0.125
            ],
            "optmul": [
              0.33,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "thermload": [
              0.6,
              0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Engine_Reinforced",
      "fdName": "Engine_Reinforced",
      "moduleKeys": [
        "t"
      ],
      "moduleName": "Thrusters",
      "name": "Drive Strengthening",
      "displayName": "Thrusters — Drive Strengthening",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+5%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.3
            ],
            "mass": [
              0.05,
              0.05
            ],
            "thermload": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.3,
              0.5
            ],
            "mass": [
              0.1,
              0.1
            ],
            "thermload": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.5,
              0.7
            ],
            "mass": [
              0.15,
              0.15
            ],
            "thermload": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+90%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.7,
              0.9
            ],
            "mass": [
              0.2,
              0.2
            ],
            "thermload": [
              -0.3,
              -0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            },
            {
              "materialKey": "imperialshielding",
              "name": "Imperial Shielding",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-50%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+110%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.9,
              1.1
            ],
            "mass": [
              0.25,
              0.25
            ],
            "thermload": [
              -0.4,
              -0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Engine_Tuned",
      "fdName": "Engine_Tuned",
      "moduleKeys": [
        "t"
      ],
      "moduleName": "Thrusters",
      "name": "Clean Drive Tuning",
      "displayName": "Thrusters — Clean Drive Tuning",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Optimal Mass",
              "effect": "-2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "optmass": [
              -0.02,
              -0.02
            ],
            "optmul": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+13%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.04,
              -0.04
            ],
            "optmass": [
              -0.04,
              -0.04
            ],
            "optmul": [
              0.08,
              0.13
            ],
            "power": [
              0.04,
              0.04
            ],
            "thermload": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+18%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-40%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.08,
              -0.08
            ],
            "optmass": [
              -0.06,
              -0.06
            ],
            "optmul": [
              0.13,
              0.18
            ],
            "power": [
              0.08,
              0.08
            ],
            "thermload": [
              -0.3,
              -0.4
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+23%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.12,
              -0.12
            ],
            "optmass": [
              -0.08,
              -0.08
            ],
            "optmul": [
              0.18,
              0.23
            ],
            "power": [
              0.12,
              0.12
            ],
            "thermload": [
              -0.4,
              -0.5
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compactemissionsdata",
              "name": "Abnormal Compact Emission Data",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-16%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Optimal Multiplier",
              "effect": "+28%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.16,
              -0.16
            ],
            "optmass": [
              -0.1,
              -0.1
            ],
            "optmul": [
              0.23,
              0.28
            ],
            "power": [
              0.16,
              0.16
            ],
            "thermload": [
              -0.5,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FSD_FastBoot",
      "fdName": "FSD_FastBoot",
      "moduleKeys": [
        "fsd"
      ],
      "moduleName": "Frame Shift Drive",
      "name": "Faster FSD Boot Sequence",
      "displayName": "Frame Shift Drive — Faster FSD Boot Sequence",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              0,
              -0.2
            ],
            "integrity": [
              -0.03,
              -0.03
            ],
            "optmass": [
              0,
              0.03
            ],
            "thermload": [
              0.04,
              0.04
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.2,
              -0.35
            ],
            "integrity": [
              -0.06,
              -0.06
            ],
            "optmass": [
              0.03,
              0.06
            ],
            "thermload": [
              0.08,
              0.08
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            },
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-50%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.35,
              -0.5
            ],
            "integrity": [
              -0.09,
              -0.09
            ],
            "optmass": [
              0.06,
              0.09
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+16%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.5,
              -0.65
            ],
            "integrity": [
              -0.12,
              -0.12
            ],
            "optmass": [
              0.09,
              0.12
            ],
            "thermload": [
              0.16,
              0.16
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "tellurium",
              "name": "Tellurium",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-80%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.65,
              -0.8
            ],
            "integrity": [
              -0.15,
              -0.15
            ],
            "optmass": [
              0.12,
              0.15
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FSD_LongRange",
      "fdName": "FSD_LongRange",
      "moduleKeys": [
        "fsd"
      ],
      "moduleName": "Frame Shift Drive",
      "name": "Increased FSD Range",
      "displayName": "Frame Shift Drive — Increased FSD Range",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "atypicaldisruptedwakeechoes",
              "name": "Atypical Disrupted Wake Echoes",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.03,
              -0.03
            ],
            "mass": [
              0.1,
              0.1
            ],
            "optmass": [
              0,
              0.15
            ],
            "power": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "atypicaldisruptedwakeechoes",
              "name": "Atypical Disrupted Wake Echoes",
              "size": 1
            },
            {
              "materialKey": "chemicalprocessors",
              "name": "Chemical Processors",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "+25%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.06,
              -0.06
            ],
            "mass": [
              0.15,
              0.15
            ],
            "optmass": [
              0.15,
              0.25
            ],
            "power": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chemicalprocessors",
              "name": "Chemical Processors",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "strangewakesolutions",
              "name": "Strange Wake Solutions",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "+35%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.09,
              -0.09
            ],
            "mass": [
              0.2,
              0.2
            ],
            "optmass": [
              0.25,
              0.35
            ],
            "power": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "chemicaldistillery",
              "name": "Chemical Distillery",
              "size": 1
            },
            {
              "materialKey": "eccentrichyperspacetrajectories",
              "name": "Eccentric Hyperspace Trajectories",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "+45%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.12,
              -0.12
            ],
            "mass": [
              0.25,
              0.25
            ],
            "optmass": [
              0.35,
              0.45
            ],
            "power": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "arsenic",
              "name": "Arsenic",
              "size": 1
            },
            {
              "materialKey": "chemicalmanipulators",
              "name": "Chemical Manipulators",
              "size": 1
            },
            {
              "materialKey": "dataminedwakeexceptions",
              "name": "Datamined Wake Exceptions",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "+55%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.15,
              -0.15
            ],
            "mass": [
              0.3,
              0.3
            ],
            "optmass": [
              0.45,
              0.55
            ],
            "power": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FSD_Shielded",
      "fdName": "FSD_Shielded",
      "moduleKeys": [
        "fsd"
      ],
      "moduleName": "Frame Shift Drive",
      "name": "Shielded FSD",
      "displayName": "Frame Shift Drive — Shielded FSD",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.25
            ],
            "mass": [
              0.04,
              0.04
            ],
            "optmass": [
              0,
              0.03
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.25,
              0.5
            ],
            "mass": [
              0.08,
              0.08
            ],
            "optmass": [
              0.03,
              0.06
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Chloe Sedesi",
            "Colonel Bris Dekker",
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon",
            "Professor Palin"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.5,
              0.75
            ],
            "mass": [
              0.12,
              0.12
            ],
            "optmass": [
              0.06,
              0.09
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+16%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.75,
              1
            ],
            "mass": [
              0.16,
              0.16
            ],
            "optmass": [
              0.09,
              0.12
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "imperialshielding",
              "name": "Imperial Shielding",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Felicity Farseer",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Optimal Mass",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+125%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1,
              1.25
            ],
            "mass": [
              0.2,
              0.2
            ],
            "optmass": [
              0.12,
              0.15
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FSDinterdictor_Expanded",
      "fdName": "FSDinterdictor_Expanded",
      "moduleKeys": [
        "fi"
      ],
      "moduleName": "Frame Shift Drive Interdictor",
      "name": "Expanded FSD Interdictor Capture Arc",
      "displayName": "Frame Shift Drive Interdictor — Expanded FSD Interdictor Capture Arc",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Felicity Farseer",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Facing Limit",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              0,
              0.4
            ],
            "power": [
              0.1,
              0.1
            ],
            "ranget": [
              -0.1,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "unusualencryptedfiles",
              "name": "Unusual Encrypted Files",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Facing Limit",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Range",
              "effect": "-15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              0.4,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "ranget": [
              -0.15,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "taggedencryptioncodes",
              "name": "Tagged Encryption Codes",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Facing Limit",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Range",
              "effect": "-20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              0.6,
              0.8
            ],
            "power": [
              0.3,
              0.3
            ],
            "ranget": [
              -0.2,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "encodedscandata",
              "name": "Divergent Scan Data",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "strangewakesolutions",
              "name": "Strange Wake Solutions",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Facing Limit",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Range",
              "effect": "-25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              0.8,
              1
            ],
            "power": [
              0.4,
              0.4
            ],
            "ranget": [
              -0.25,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "classifiedscandata",
              "name": "Classified Scan Fragment",
              "size": 1
            },
            {
              "materialKey": "eccentrichyperspacetrajectories",
              "name": "Eccentric Hyperspace Trajectories",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            }
          ],
          "engineers": [
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Facing Limit",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Range",
              "effect": "-30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              1,
              1.2
            ],
            "power": [
              0.5,
              0.5
            ],
            "ranget": [
              -0.3,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FSDinterdictor_LongRange",
      "fdName": "FSDinterdictor_LongRange",
      "moduleKeys": [
        "fi"
      ],
      "moduleName": "Frame Shift Drive Interdictor",
      "name": "Long Range FSD Interdictor",
      "displayName": "Frame Shift Drive Interdictor — Long Range FSD Interdictor",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "unusualencryptedfiles",
              "name": "Unusual Encrypted Files",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Felicity Farseer",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Facing Limit",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              -0.1,
              -0.1
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.1,
              0.1
            ],
            "ranget": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "atypicaldisruptedwakeechoes",
              "name": "Atypical Disrupted Wake Echoes",
              "size": 1
            },
            {
              "materialKey": "taggedencryptioncodes",
              "name": "Tagged Encryption Codes",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Facing Limit",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              -0.15,
              -0.15
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.2,
              0.2
            ],
            "ranget": [
              0.2,
              0.3
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "anomalousbulkscandata",
              "name": "Anomalous Bulk Scan Data",
              "size": 1
            },
            {
              "materialKey": "anomalousfsdtelemetry",
              "name": "Anomalous FSD Telemetry",
              "size": 1
            },
            {
              "materialKey": "opensymmetrickeys",
              "name": "Open Symmetric Keys",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Facing Limit",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              -0.2,
              -0.2
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.3,
              0.3
            ],
            "ranget": [
              0.3,
              0.4
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "atypicalencryptionarchives",
              "name": "Atypical Encryption Archives",
              "size": 1
            },
            {
              "materialKey": "strangewakesolutions",
              "name": "Strange Wake Solutions",
              "size": 1
            },
            {
              "materialKey": "unidentifiedscanarchives",
              "name": "Unidentified Scan Archives",
              "size": 1
            }
          ],
          "engineers": [
            "Colonel Bris Dekker",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Facing Limit",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              -0.25,
              -0.25
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.4,
              0.4
            ],
            "ranget": [
              0.4,
              0.5
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "adaptiveencryptorscapture",
              "name": "Adaptive Encryptors Capture",
              "size": 1
            },
            {
              "materialKey": "eccentrichyperspacetrajectories",
              "name": "Eccentric Hyperspace Trajectories",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Facing Limit",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "facinglimit": [
              -0.3,
              -0.3
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.5,
              0.5
            ],
            "ranget": [
              0.5,
              0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FuelScoop_Shielded",
      "fdName": "FuelScoop_Shielded",
      "moduleKeys": [
        "fs"
      ],
      "moduleName": "Fuel Scoop",
      "name": "Shielded",
      "displayName": "Fuel Scoop — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FuelTransferLimpet_LightWeight",
      "fdName": "FuelTransferLimpet_LightWeight",
      "moduleKeys": [
        "fx"
      ],
      "moduleName": "Fuel Transfer Limpet Controller",
      "name": "Lightweight",
      "displayName": "Fuel Transfer Limpet Controller — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FuelTransferLimpet_Reinforced",
      "fdName": "FuelTransferLimpet_Reinforced",
      "moduleKeys": [
        "fx"
      ],
      "moduleName": "Fuel Transfer Limpet Controller",
      "name": "Reinforced",
      "displayName": "Fuel Transfer Limpet Controller — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "FuelTransferLimpet_Shielded",
      "fdName": "FuelTransferLimpet_Shielded",
      "moduleKeys": [
        "fx"
      ],
      "moduleName": "Fuel Transfer Limpet Controller",
      "name": "Shielded",
      "displayName": "Fuel Transfer Limpet Controller — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HatchBreakerLimpet_LightWeight",
      "fdName": "HatchBreakerLimpet_LightWeight",
      "moduleKeys": [
        "hb"
      ],
      "moduleName": "Hatch Breaker Limpet Controller",
      "name": "Lightweight",
      "displayName": "Hatch Breaker Limpet Controller — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HatchBreakerLimpet_Reinforced",
      "fdName": "HatchBreakerLimpet_Reinforced",
      "moduleKeys": [
        "hb"
      ],
      "moduleName": "Hatch Breaker Limpet Controller",
      "name": "Reinforced",
      "displayName": "Hatch Breaker Limpet Controller — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HatchBreakerLimpet_Shielded",
      "fdName": "HatchBreakerLimpet_Shielded",
      "moduleKeys": [
        "hb"
      ],
      "moduleName": "Hatch Breaker Limpet Controller",
      "name": "Shielded",
      "displayName": "Hatch Breaker Limpet Controller — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HullReinforcement_Advanced",
      "fdName": "HullReinforcement_Advanced",
      "moduleKeys": [
        "hr"
      ],
      "moduleName": "Hull Reinforcement Package",
      "name": "Lightweight Hull Reinforcement",
      "displayName": "Hull Reinforcement Package — Lightweight Hull Reinforcement",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Hull Boost",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "hullboost": [
              0,
              0.08
            ],
            "hullreinforcement": [
              -0.04,
              -0.04
            ],
            "mass": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Hull Boost",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "hullboost": [
              0.08,
              0.12
            ],
            "hullreinforcement": [
              -0.08,
              -0.08
            ],
            "mass": [
              -0.08,
              -0.12
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Hull Boost",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-16%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "hullboost": [
              0.12,
              0.16
            ],
            "hullreinforcement": [
              -0.12,
              -0.12
            ],
            "mass": [
              -0.12,
              -0.16
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "-16%",
              "isGood": false
            },
            {
              "property": "Hull Boost",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "hullboost": [
              0.16,
              0.2
            ],
            "hullreinforcement": [
              -0.16,
              -0.16
            ],
            "mass": [
              -0.16,
              -0.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "militarygradealloys",
              "name": "Military Grade Alloys",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Hull Boost",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-24%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "hullboost": [
              0.2,
              0.24
            ],
            "hullreinforcement": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.2,
              -0.24
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HullReinforcement_Explosive",
      "fdName": "HullReinforcement_Explosive",
      "moduleKeys": [
        "hr"
      ],
      "moduleName": "Hull Reinforcement Package",
      "name": "Blast Resistant Hull Reinforcement",
      "displayName": "Hull Reinforcement Package — Blast Resistant Hull Reinforcement",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+3%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.12
            ],
            "hullreinforcement": [
              0,
              0.03
            ],
            "kinres": [
              -0.02,
              -0.02
            ],
            "thermres": [
              -0.02,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+6%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.12,
              0.19
            ],
            "hullreinforcement": [
              0.03,
              0.06
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+9%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.19,
              0.26
            ],
            "hullreinforcement": [
              0.06,
              0.09
            ],
            "kinres": [
              -0.06,
              -0.06
            ],
            "thermres": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "mercury",
              "name": "Mercury",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.26,
              0.33
            ],
            "hullreinforcement": [
              0.09,
              0.12
            ],
            "kinres": [
              -0.08,
              -0.08
            ],
            "thermres": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "ruthenium",
              "name": "Ruthenium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.33,
              0.4
            ],
            "hullreinforcement": [
              0.12,
              0.15
            ],
            "kinres": [
              -0.1,
              -0.1
            ],
            "thermres": [
              -0.1,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HullReinforcement_HeavyDuty",
      "fdName": "HullReinforcement_HeavyDuty",
      "moduleKeys": [
        "hr"
      ],
      "moduleName": "Hull Reinforcement Package",
      "name": "Heavy Duty Hull Reinforcement",
      "displayName": "Hull Reinforcement Package — Heavy Duty Hull Reinforcement",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "All Resistances",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.03
            ],
            "hullreinforcement": [
              0,
              0.24
            ],
            "kinres": [
              0,
              0.03
            ],
            "mass": [
              0.08,
              0.08
            ],
            "thermres": [
              0,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "All Resistances",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+16%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.03,
              0.06
            ],
            "hullreinforcement": [
              0.24,
              0.36
            ],
            "kinres": [
              0.03,
              0.06
            ],
            "mass": [
              0.16,
              0.16
            ],
            "thermres": [
              0.03,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "+48%",
              "isGood": true
            },
            {
              "property": "All Resistances",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+24%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.06,
              0.09
            ],
            "hullreinforcement": [
              0.36,
              0.48
            ],
            "kinres": [
              0.06,
              0.09
            ],
            "mass": [
              0.24,
              0.24
            ],
            "thermres": [
              0.06,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "All Resistances",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+32%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.09,
              0.12
            ],
            "hullreinforcement": [
              0.48,
              0.6
            ],
            "kinres": [
              0.09,
              0.12
            ],
            "mass": [
              0.32,
              0.32
            ],
            "thermres": [
              0.09,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Hull Reinforcement",
              "effect": "+72%",
              "isGood": true
            },
            {
              "property": "All Resistances",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.12,
              0.15
            ],
            "hullreinforcement": [
              0.6,
              0.72
            ],
            "kinres": [
              0.12,
              0.15
            ],
            "mass": [
              0.4,
              0.4
            ],
            "thermres": [
              0.12,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HullReinforcement_Kinetic",
      "fdName": "HullReinforcement_Kinetic",
      "moduleKeys": [
        "hr"
      ],
      "moduleName": "Hull Reinforcement Package",
      "name": "Kinetic Resistant Hull Reinforcement",
      "displayName": "Hull Reinforcement Package — Kinetic Resistant Hull Reinforcement",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+3%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.02,
              -0.02
            ],
            "hullreinforcement": [
              0,
              0.03
            ],
            "kinres": [
              0,
              0.12
            ],
            "thermres": [
              -0.02,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+6%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "hullreinforcement": [
              0.03,
              0.06
            ],
            "kinres": [
              0.12,
              0.19
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+9%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.06,
              -0.06
            ],
            "hullreinforcement": [
              0.06,
              0.09
            ],
            "kinres": [
              0.19,
              0.26
            ],
            "thermres": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.08,
              -0.08
            ],
            "hullreinforcement": [
              0.09,
              0.12
            ],
            "kinres": [
              0.26,
              0.33
            ],
            "thermres": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Kinetic Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.1,
              -0.1
            ],
            "hullreinforcement": [
              0.12,
              0.15
            ],
            "kinres": [
              0.33,
              0.4
            ],
            "thermres": [
              -0.1,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "HullReinforcement_Thermic",
      "fdName": "HullReinforcement_Thermic",
      "moduleKeys": [
        "hr"
      ],
      "moduleName": "Hull Reinforcement Package",
      "name": "Thermal Resistant Hull Reinforcement",
      "displayName": "Hull Reinforcement Package — Thermal Resistant Hull Reinforcement",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+3%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.02,
              -0.02
            ],
            "hullreinforcement": [
              0,
              0.03
            ],
            "kinres": [
              -0.02,
              -0.02
            ],
            "thermres": [
              0,
              0.12
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+19%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+6%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "hullreinforcement": [
              0.03,
              0.06
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              0.12,
              0.19
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+9%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.06,
              -0.06
            ],
            "hullreinforcement": [
              0.06,
              0.09
            ],
            "kinres": [
              -0.06,
              -0.06
            ],
            "thermres": [
              0.19,
              0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+33%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.08,
              -0.08
            ],
            "hullreinforcement": [
              0.09,
              0.12
            ],
            "kinres": [
              -0.08,
              -0.08
            ],
            "thermres": [
              0.26,
              0.33
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Selene Jean"
          ],
          "effects": [
            {
              "property": "Explosive Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Kinetic Resistance",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Hull Reinforcement",
              "effect": "+15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.1,
              -0.1
            ],
            "hullreinforcement": [
              0.12,
              0.15
            ],
            "kinres": [
              -0.1,
              -0.1
            ],
            "thermres": [
              0.33,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "LifeSupport_LightWeight",
      "fdName": "LifeSupport_LightWeight",
      "moduleKeys": [
        "ls"
      ],
      "moduleName": "Life Support",
      "name": "Lightweight",
      "displayName": "Life Support — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "LifeSupport_Reinforced",
      "fdName": "LifeSupport_Reinforced",
      "moduleKeys": [
        "ls"
      ],
      "moduleName": "Life Support",
      "name": "Reinforced",
      "displayName": "Life Support — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "LifeSupport_Shielded",
      "fdName": "LifeSupport_Shielded",
      "moduleKeys": [
        "ls"
      ],
      "moduleName": "Life Support",
      "name": "Shielded",
      "displayName": "Life Support — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1.12,
              1.12
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_ChaffCapacity",
      "fdName": "Misc_ChaffCapacity",
      "moduleKeys": [
        "ch"
      ],
      "moduleName": "Chaff Launcher",
      "name": "Ammo Capacity",
      "displayName": "Chaff Launcher — Ammo Capacity",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Reload Time",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Ammo Maximum",
              "effect": "+50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.5
            ],
            "mass": [
              1,
              1
            ],
            "reload": [
              0.1,
              0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_HeatSinkCapacity",
      "fdName": "Misc_HeatSinkCapacity",
      "moduleKeys": [
        "csl",
        "hs"
      ],
      "moduleName": "Heat Sink Launcher",
      "name": "Ammo Capacity",
      "displayName": "Heat Sink Launcher — Ammo Capacity",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Reload Time",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Ammo Maximum",
              "effect": "+50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.49,
              0.49
            ],
            "mass": [
              1,
              1
            ],
            "reload": [
              0.5,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--chaff-launcher",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Chaff Launcher",
      "name": "Lightweight",
      "displayName": "Chaff Launcher — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--electronic-countermeasure",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Electronic Countermeasure",
      "name": "Lightweight",
      "displayName": "Electronic Countermeasure — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--heat-sink-launcher",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Heat Sink Launcher",
      "name": "Lightweight",
      "displayName": "Heat Sink Launcher — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--kill-warrant-scanner",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Lightweight",
      "displayName": "Kill Warrant Scanner — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--manifest-scanner",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Lightweight",
      "displayName": "Manifest Scanner — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--point-defence",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Point Defence",
      "name": "Lightweight",
      "displayName": "Point Defence — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_LightWeight--wake-scanner",
      "fdName": "Misc_LightWeight",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Lightweight",
      "displayName": "Wake Scanner — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_PointDefenseCapacity",
      "fdName": "Misc_PointDefenseCapacity",
      "moduleKeys": [
        "po"
      ],
      "moduleName": "Point Defence",
      "name": "Ammo Capacity",
      "displayName": "Point Defence — Ammo Capacity",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Reload Time",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Ammo Maximum",
              "effect": "+50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.5
            ],
            "mass": [
              1,
              1
            ],
            "reload": [
              0.1,
              0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Chaff Launcher",
      "name": "Reinforced",
      "displayName": "Chaff Launcher — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Electronic Countermeasure",
      "name": "Reinforced",
      "displayName": "Electronic Countermeasure — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Heat Sink Launcher",
      "name": "Reinforced",
      "displayName": "Heat Sink Launcher — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Reinforced",
      "displayName": "Kill Warrant Scanner — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Reinforced",
      "displayName": "Manifest Scanner — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Point Defence",
      "name": "Reinforced",
      "displayName": "Point Defence — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Reinforced",
      "fdName": "Misc_Reinforced",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Reinforced",
      "displayName": "Wake Scanner — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Chaff Launcher",
      "name": "Shielded",
      "displayName": "Chaff Launcher — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Electronic Countermeasure",
      "name": "Shielded",
      "displayName": "Electronic Countermeasure — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Heat Sink Launcher",
      "name": "Shielded",
      "displayName": "Heat Sink Launcher — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Shielded",
      "displayName": "Kill Warrant Scanner — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Shielded",
      "displayName": "Manifest Scanner — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Point Defence",
      "name": "Shielded",
      "displayName": "Point Defence — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Petra Olmanova",
            "Ram Tah"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Misc_Shielded",
      "fdName": "Misc_Shielded",
      "moduleKeys": [
        "ch",
        "cs",
        "csl",
        "ec",
        "hs",
        "kw",
        "po",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Shielded",
      "displayName": "Wake Scanner — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_HighCapacity",
      "fdName": "PowerDistributor_HighCapacity",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "High Charge Capacity",
      "displayName": "Power Distributor — High Charge Capacity",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Recharge",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Power Capacity",
              "effect": "+10%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0,
              0.1
            ],
            "engrate": [
              -0.02,
              -0.02
            ],
            "integrity": [
              0,
              0.1
            ],
            "syscap": [
              0,
              0.1
            ],
            "sysrate": [
              -0.02,
              -0.02
            ],
            "wepcap": [
              0,
              0.1
            ],
            "weprate": [
              -0.02,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Recharge",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Power Capacity",
              "effect": "+18%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.1,
              0.18
            ],
            "engrate": [
              -0.06,
              -0.06
            ],
            "integrity": [
              0.1,
              0.18
            ],
            "syscap": [
              0.08,
              0.1
            ],
            "sysrate": [
              -0.06,
              -0.06
            ],
            "wepcap": [
              0.1,
              0.18
            ],
            "weprate": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Recharge",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Capacity",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.18,
              0.26
            ],
            "engrate": [
              -0.1,
              -0.1
            ],
            "integrity": [
              0.15,
              0.2
            ],
            "syscap": [
              0.18,
              0.26
            ],
            "sysrate": [
              -0.1,
              -0.1
            ],
            "wepcap": [
              0.18,
              0.26
            ],
            "weprate": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Recharge",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+25%",
              "isGood": true
            },
            {
              "property": "Power Capacity",
              "effect": "+34%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.26,
              0.34
            ],
            "engrate": [
              -0.14,
              -0.14
            ],
            "integrity": [
              0.2,
              0.25
            ],
            "syscap": [
              0.26,
              0.34
            ],
            "sysrate": [
              -0.14,
              -0.14
            ],
            "wepcap": [
              0.26,
              0.34
            ],
            "weprate": [
              -0.14,
              -0.14
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Recharge",
              "effect": "-18%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Power Capacity",
              "effect": "+42%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.34,
              0.42
            ],
            "engrate": [
              -0.18,
              -0.18
            ],
            "integrity": [
              0.25,
              0.3
            ],
            "syscap": [
              0.34,
              0.42
            ],
            "sysrate": [
              -0.18,
              -0.18
            ],
            "wepcap": [
              0.34,
              0.42
            ],
            "weprate": [
              -0.18,
              -0.18
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_HighFrequency",
      "fdName": "PowerDistributor_HighFrequency",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "Charge Enhanced",
      "displayName": "Power Distributor — Charge Enhanced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Capacity",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Power Recharge",
              "effect": "+9%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.01,
              -0.01
            ],
            "engrate": [
              0,
              0.09
            ],
            "syscap": [
              -0.01,
              -0.01
            ],
            "sysrate": [
              0,
              0.09
            ],
            "wepcap": [
              -0.01,
              -0.01
            ],
            "weprate": [
              0,
              0.09
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "chemicalprocessors",
              "name": "Chemical Processors",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Capacity",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Power Recharge",
              "effect": "+18%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.02,
              -0.02
            ],
            "engrate": [
              0.09,
              0.18
            ],
            "syscap": [
              -0.02,
              -0.02
            ],
            "sysrate": [
              0.09,
              0.18
            ],
            "wepcap": [
              -0.02,
              -0.02
            ],
            "weprate": [
              0.09,
              0.18
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chemicaldistillery",
              "name": "Chemical Distillery",
              "size": 1
            },
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Power Recharge",
              "effect": "+27%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.03,
              -0.03
            ],
            "engrate": [
              0.18,
              0.27
            ],
            "syscap": [
              -0.03,
              -0.03
            ],
            "sysrate": [
              0.18,
              0.27
            ],
            "wepcap": [
              -0.03,
              -0.03
            ],
            "weprate": [
              0.18,
              0.27
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "chemicalmanipulators",
              "name": "Chemical Manipulators",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Capacity",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Power Recharge",
              "effect": "+36%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.04,
              -0.04
            ],
            "engrate": [
              0.27,
              0.36
            ],
            "syscap": [
              -0.04,
              -0.04
            ],
            "sysrate": [
              0.27,
              0.36
            ],
            "wepcap": [
              -0.04,
              -0.04
            ],
            "weprate": [
              0.27,
              0.36
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "chemicalmanipulators",
              "name": "Chemical Manipulators",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "exquisitefocuscrystals",
              "name": "Exquisite Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Capacity",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Power Recharge",
              "effect": "+45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.05,
              -0.05
            ],
            "engrate": [
              0.36,
              0.45
            ],
            "syscap": [
              -0.05,
              -0.05
            ],
            "sysrate": [
              0.36,
              0.45
            ],
            "wepcap": [
              -0.05,
              -0.05
            ],
            "weprate": [
              0.36,
              0.45
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_PriorityEngines",
      "fdName": "PowerDistributor_PriorityEngines",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "Engine Focused",
      "displayName": "Power Distributor — Engine Focused",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Weapons Recharge",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "+16%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0,
              0.2
            ],
            "engrate": [
              0,
              0.16
            ],
            "syscap": [
              -0.03,
              -0.03
            ],
            "sysrate": [
              -0.03,
              -0.03
            ],
            "wepcap": [
              -0.03,
              -0.03
            ],
            "weprate": [
              -0.01,
              -0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Weapons Recharge",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "+23%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.2,
              0.3
            ],
            "engrate": [
              0.16,
              0.23
            ],
            "syscap": [
              -0.06,
              -0.06
            ],
            "sysrate": [
              -0.06,
              -0.06
            ],
            "wepcap": [
              -0.06,
              -0.06
            ],
            "weprate": [
              -0.02,
              -0.02
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "anomalousbulkscandata",
              "name": "Anomalous Bulk Scan Data",
              "size": 1
            },
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Weapons Recharge",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "+30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.3,
              0.4
            ],
            "engrate": [
              0.23,
              0.3
            ],
            "syscap": [
              -0.09,
              -0.09
            ],
            "sysrate": [
              -0.09,
              -0.09
            ],
            "wepcap": [
              -0.09,
              -0.09
            ],
            "weprate": [
              -0.03,
              -0.03
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            },
            {
              "materialKey": "unidentifiedscanarchives",
              "name": "Unidentified Scan Archives",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Weapons Recharge",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "+37%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.4,
              0.5
            ],
            "engrate": [
              0.3,
              0.37
            ],
            "syscap": [
              -0.12,
              -0.12
            ],
            "sysrate": [
              -0.12,
              -0.12
            ],
            "wepcap": [
              -0.12,
              -0.12
            ],
            "weprate": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Weapons Recharge",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              0.5,
              0.6
            ],
            "engrate": [
              0.37,
              0.44
            ],
            "syscap": [
              -0.15,
              -0.15
            ],
            "sysrate": [
              -0.15,
              -0.15
            ],
            "wepcap": [
              -0.15,
              -0.15
            ],
            "weprate": [
              -0.05,
              -0.05
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_PrioritySystems",
      "fdName": "PowerDistributor_PrioritySystems",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "System Focused",
      "displayName": "Power Distributor — System Focused",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Systems Capacity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Engines Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "-1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.03,
              -0.03
            ],
            "engrate": [
              -0.01,
              -0.01
            ],
            "syscap": [
              0,
              0.2
            ],
            "sysrate": [
              0,
              0.16
            ],
            "wepcap": [
              -0.03,
              -0.03
            ],
            "weprate": [
              -0.03,
              -0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "+23%",
              "isGood": true
            },
            {
              "property": "Systems Capacity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Engines Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "-2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.06,
              -0.06
            ],
            "engrate": [
              -0.02,
              -0.02
            ],
            "syscap": [
              0.2,
              0.3
            ],
            "sysrate": [
              0.16,
              0.23
            ],
            "wepcap": [
              -0.06,
              -0.06
            ],
            "weprate": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "anomalousbulkscandata",
              "name": "Anomalous Bulk Scan Data",
              "size": 1
            },
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Systems Capacity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Engines Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.09,
              -0.09
            ],
            "engrate": [
              -0.03,
              -0.03
            ],
            "syscap": [
              0.3,
              0.4
            ],
            "sysrate": [
              0.23,
              0.3
            ],
            "wepcap": [
              -0.09,
              -0.09
            ],
            "weprate": [
              -0.09,
              -0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            },
            {
              "materialKey": "unidentifiedscanarchives",
              "name": "Unidentified Scan Archives",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "+37%",
              "isGood": true
            },
            {
              "property": "Systems Capacity",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Engines Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.12,
              -0.12
            ],
            "engrate": [
              -0.04,
              -0.04
            ],
            "syscap": [
              0.4,
              0.5
            ],
            "sysrate": [
              0.3,
              0.37
            ],
            "wepcap": [
              -0.12,
              -0.12
            ],
            "weprate": [
              -0.12,
              -0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Systems Recharge",
              "effect": "+44%",
              "isGood": true
            },
            {
              "property": "Systems Capacity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Engines Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Engines Recharge",
              "effect": "-5%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "engcap": [
              -0.15,
              -0.15
            ],
            "engrate": [
              -0.05,
              -0.05
            ],
            "syscap": [
              0.5,
              0.6
            ],
            "sysrate": [
              0.37,
              0.44
            ],
            "wepcap": [
              -0.15,
              -0.15
            ],
            "weprate": [
              -0.15,
              -0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_PriorityWeapons",
      "fdName": "PowerDistributor_PriorityWeapons",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "Weapon Focused",
      "displayName": "Power Distributor — Weapon Focused",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Systems Recharge",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Engines Recharge",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "engcap": [
              -0.03,
              -0.03
            ],
            "engrate": [
              -0.03,
              -0.03
            ],
            "syscap": [
              -0.03,
              -0.03
            ],
            "sysrate": [
              -0.01,
              -0.01
            ],
            "wepcap": [
              0,
              0.2
            ],
            "weprate": [
              0,
              0.16
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Systems Recharge",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "+23%",
              "isGood": true
            },
            {
              "property": "Engines Recharge",
              "effect": "-6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "engcap": [
              -0.06,
              -0.06
            ],
            "engrate": [
              -0.06,
              -0.06
            ],
            "syscap": [
              -0.06,
              -0.06
            ],
            "sysrate": [
              -0.02,
              -0.02
            ],
            "wepcap": [
              0.2,
              0.3
            ],
            "weprate": [
              0.16,
              0.23
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "anomalousbulkscandata",
              "name": "Anomalous Bulk Scan Data",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Systems Recharge",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Engines Recharge",
              "effect": "-9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "engcap": [
              -0.09,
              -0.09
            ],
            "engrate": [
              -0.09,
              -0.09
            ],
            "syscap": [
              -0.09,
              -0.09
            ],
            "sysrate": [
              -0.03,
              -0.03
            ],
            "wepcap": [
              0.3,
              0.4
            ],
            "weprate": [
              0.23,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "unidentifiedscanarchives",
              "name": "Unidentified Scan Archives",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Systems Recharge",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "+37%",
              "isGood": true
            },
            {
              "property": "Engines Recharge",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "engcap": [
              -0.12,
              -0.12
            ],
            "engrate": [
              -0.12,
              -0.12
            ],
            "syscap": [
              -0.12,
              -0.12
            ],
            "sysrate": [
              -0.04,
              -0.04
            ],
            "wepcap": [
              0.4,
              0.5
            ],
            "weprate": [
              0.3,
              0.37
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            },
            {
              "materialKey": "tellurium",
              "name": "Tellurium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Weapons Capacity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Systems Recharge",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Systems Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Engines Capacity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Weapons Recharge",
              "effect": "+44%",
              "isGood": true
            },
            {
              "property": "Engines Recharge",
              "effect": "-15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "engcap": [
              -0.15,
              -0.15
            ],
            "engrate": [
              -0.15,
              -0.15
            ],
            "syscap": [
              -0.15,
              -0.15
            ],
            "sysrate": [
              -0.05,
              -0.05
            ],
            "wepcap": [
              0.5,
              0.6
            ],
            "weprate": [
              0.37,
              0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerDistributor_Shielded",
      "fdName": "PowerDistributor_Shielded",
      "moduleKeys": [
        "pd"
      ],
      "moduleName": "Power Distributor",
      "name": "Shielded",
      "displayName": "Power Distributor — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0,
              0.4
            ],
            "mass": [
              0.03,
              0.03
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.4,
              0.8
            ],
            "mass": [
              0.06,
              0.06
            ],
            "power": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              0.8,
              1.2
            ],
            "mass": [
              0.09,
              0.09
            ],
            "power": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+160%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.2,
              1.6
            ],
            "mass": [
              0.12,
              0.12
            ],
            "power": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              1.6,
              2
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerPlant_Armoured",
      "fdName": "PowerPlant_Armoured",
      "moduleKeys": [
        "pp"
      ],
      "moduleName": "Power Plant",
      "name": "Armoured",
      "displayName": "Power Plant — Armoured",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Power Generation",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Heat Efficiency",
              "effect": "-4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0,
              -0.04
            ],
            "integrity": [
              0,
              0.4
            ],
            "pgen": [
              0,
              0.04
            ],
            "mass": [
              0.04,
              0.04
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Power Generation",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Heat Efficiency",
              "effect": "-6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.04,
              -0.06
            ],
            "integrity": [
              0.3,
              0.6
            ],
            "pgen": [
              0,
              0.06
            ],
            "mass": [
              0.08,
              0.08
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Power Generation",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Heat Efficiency",
              "effect": "-8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.06,
              -0.08
            ],
            "integrity": [
              0.6,
              0.8
            ],
            "pgen": [
              0.06,
              0.08
            ],
            "mass": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Power Generation",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Heat Efficiency",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+16%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.08,
              -0.1
            ],
            "integrity": [
              0.5,
              1
            ],
            "pgen": [
              0.08,
              0.1
            ],
            "mass": [
              0.16,
              0.16
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani"
          ],
          "effects": [
            {
              "property": "Power Generation",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Heat Efficiency",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.1,
              -0.12
            ],
            "integrity": [
              1,
              1.2
            ],
            "pgen": [
              0.1,
              0.12
            ],
            "mass": [
              0.2,
              0.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerPlant_Boosted",
      "fdName": "PowerPlant_Boosted",
      "moduleKeys": [
        "pp"
      ],
      "moduleName": "Power Plant",
      "name": "Overcharged",
      "displayName": "Power Plant — Overcharged",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "+5%",
              "isGood": false
            },
            {
              "property": "Power Generation",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0.05,
              0.05
            ],
            "integrity": [
              -0.05,
              -0.05
            ],
            "pgen": [
              0,
              0.12
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Power Generation",
              "effect": "+19%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0.1,
              0.1
            ],
            "integrity": [
              -0.1,
              -0.1
            ],
            "pgen": [
              0.12,
              0.19
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Power Generation",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0.15,
              0.15
            ],
            "integrity": [
              -0.15,
              -0.15
            ],
            "pgen": [
              0.19,
              0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Power Generation",
              "effect": "+33%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0.2,
              0.2
            ],
            "integrity": [
              -0.2,
              -0.2
            ],
            "pgen": [
              0.26,
              0.33
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "chemicalmanipulators",
              "name": "Chemical Manipulators",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "tellurium",
              "name": "Tellurium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Power Generation",
              "effect": "+40%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0.25,
              0.25
            ],
            "integrity": [
              -0.25,
              -0.25
            ],
            "pgen": [
              0.33,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "PowerPlant_Stealth",
      "fdName": "PowerPlant_Stealth",
      "moduleKeys": [
        "pp"
      ],
      "moduleName": "Power Plant",
      "name": "Low Emissions",
      "displayName": "Power Plant — Low Emissions",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Mass",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Power Generation",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              0,
              -0.25
            ],
            "mass": [
              0.04,
              0.04
            ],
            "pgen": [
              -0.03,
              -0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Mass",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Power Generation",
              "effect": "-6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.25,
              -0.35
            ],
            "mass": [
              0.08,
              0.08
            ],
            "pgen": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Mass",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Power Generation",
              "effect": "-9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.35,
              -0.45
            ],
            "mass": [
              0.12,
              0.12
            ],
            "pgen": [
              -0.09,
              -0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani",
            "Marco Qwent"
          ],
          "effects": [
            {
              "property": "Mass",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Power Generation",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.45,
              -0.55
            ],
            "mass": [
              0.16,
              0.16
            ],
            "pgen": [
              -0.12,
              -0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Hera Tani"
          ],
          "effects": [
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Heat Efficiency",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Power Generation",
              "effect": "-15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "eff": [
              -0.55,
              -0.65
            ],
            "mass": [
              0.2,
              0.2
            ],
            "pgen": [
              -0.15,
              -0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ProspectingLimpet_LightWeight",
      "fdName": "ProspectingLimpet_LightWeight",
      "moduleKeys": [
        "pc"
      ],
      "moduleName": "Prospector Limpet Controller",
      "name": "Lightweight",
      "displayName": "Prospector Limpet Controller — Lightweight",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.45
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-56%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.45,
              -0.55
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.55,
              -0.65
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.65,
              -0.75
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-85%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.75,
              -0.85
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ProspectingLimpet_Reinforced",
      "fdName": "ProspectingLimpet_Reinforced",
      "moduleKeys": [
        "pc"
      ],
      "moduleName": "Prospector Limpet Controller",
      "name": "Reinforced",
      "displayName": "Prospector Limpet Controller — Reinforced",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "mass": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "mass": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+90%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "mass": [
              0.9,
              0.9
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+120%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "mass": [
              1.2,
              1.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "mass": [
              1.5,
              1.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ProspectingLimpet_Shielded",
      "fdName": "ProspectingLimpet_Shielded",
      "moduleKeys": [
        "pc"
      ],
      "moduleName": "Prospector Limpet Controller",
      "name": "Shielded",
      "displayName": "Prospector Limpet Controller — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Ram Tah",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Refineries_Shielded",
      "fdName": "Refineries_Shielded",
      "moduleKeys": [
        "rf"
      ],
      "moduleName": "Refinery",
      "name": "Shielded",
      "displayName": "Refinery — Shielded",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "wornshieldemitters",
              "name": "Worn Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+120%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.6,
              1.2
            ],
            "power": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+60%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+180%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.2,
              1.8
            ],
            "power": [
              0.6,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "shieldingsensors",
              "name": "Shielding Sensors",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+80%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+240%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.8,
              2.4
            ],
            "power": [
              0.8,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compoundshielding",
              "name": "Compound Shielding",
              "size": 1
            },
            {
              "materialKey": "fedcorecomposites",
              "name": "Core Dynamics Composites",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+100%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.4,
              3
            ],
            "power": [
              1,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_LongRange",
      "fdName": "Scanner_LongRange",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Long Range Scanner",
      "displayName": "Kill Warrant Scanner — Long Range Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.1,
              0.1
            ],
            "angle": [
              -0.1,
              -0.1
            ],
            "range": [
              0,
              0.24
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+48%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.2,
              0.2
            ],
            "angle": [
              -0.15,
              -0.15
            ],
            "range": [
              0.24,
              0.48
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+72%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.3,
              0.3
            ],
            "angle": [
              -0.2,
              -0.2
            ],
            "range": [
              0.48,
              0.72
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+96%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.4,
              0.4
            ],
            "angle": [
              -0.25,
              -0.25
            ],
            "range": [
              0.72,
              0.96
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compactemissionsdata",
              "name": "Abnormal Compact Emission Data",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.5,
              0.5
            ],
            "angle": [
              -0.3,
              -0.3
            ],
            "range": [
              0.96,
              1.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_LongRange",
      "fdName": "Scanner_LongRange",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Long Range Scanner",
      "displayName": "Manifest Scanner — Long Range Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.1,
              0.1
            ],
            "angle": [
              -0.1,
              -0.1
            ],
            "range": [
              0,
              0.24
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+48%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.2,
              0.2
            ],
            "angle": [
              -0.15,
              -0.15
            ],
            "range": [
              0.24,
              0.48
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+72%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.3,
              0.3
            ],
            "angle": [
              -0.2,
              -0.2
            ],
            "range": [
              0.48,
              0.72
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+96%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.4,
              0.4
            ],
            "angle": [
              -0.25,
              -0.25
            ],
            "range": [
              0.72,
              0.96
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compactemissionsdata",
              "name": "Abnormal Compact Emission Data",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.5,
              0.5
            ],
            "angle": [
              -0.3,
              -0.3
            ],
            "range": [
              0.96,
              1.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_LongRange",
      "fdName": "Scanner_LongRange",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Long Range Scanner",
      "displayName": "Wake Scanner — Long Range Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.1,
              0.1
            ],
            "angle": [
              -0.1,
              -0.1
            ],
            "range": [
              0,
              0.24
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+48%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.2,
              0.2
            ],
            "angle": [
              -0.15,
              -0.15
            ],
            "range": [
              0.24,
              0.48
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+72%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.3,
              0.3
            ],
            "angle": [
              -0.2,
              -0.2
            ],
            "range": [
              0.48,
              0.72
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+96%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.4,
              0.4
            ],
            "angle": [
              -0.25,
              -0.25
            ],
            "range": [
              0.72,
              0.96
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compactemissionsdata",
              "name": "Abnormal Compact Emission Data",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "power": [
              0.5,
              0.5
            ],
            "angle": [
              -0.3,
              -0.3
            ],
            "range": [
              0.96,
              1.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_WideAngle",
      "fdName": "Scanner_WideAngle",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Wide Angle Scanner",
      "displayName": "Kill Warrant Scanner — Wide Angle Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.2,
              0.2
            ],
            "angle": [
              0,
              0.4
            ],
            "scantime": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.4,
              0.4
            ],
            "angle": [
              0.4,
              0.8
            ],
            "scantime": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.6,
              0.6
            ],
            "angle": [
              0.8,
              1.2
            ],
            "scantime": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "encodedscandata",
              "name": "Divergent Scan Data",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+160%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.8,
              0.8
            ],
            "angle": [
              1.2,
              1.6
            ],
            "scantime": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "classifiedscandata",
              "name": "Classified Scan Fragment",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              1,
              1
            ],
            "angle": [
              1.6,
              2
            ],
            "scantime": [
              0.5,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_WideAngle",
      "fdName": "Scanner_WideAngle",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Wide Angle Scanner",
      "displayName": "Manifest Scanner — Wide Angle Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.2,
              0.2
            ],
            "angle": [
              0,
              0.4
            ],
            "scantime": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.4,
              0.4
            ],
            "angle": [
              0.4,
              0.8
            ],
            "scantime": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.6,
              0.6
            ],
            "angle": [
              0.8,
              1.2
            ],
            "scantime": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "encodedscandata",
              "name": "Divergent Scan Data",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+160%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.8,
              0.8
            ],
            "angle": [
              1.2,
              1.6
            ],
            "scantime": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "classifiedscandata",
              "name": "Classified Scan Fragment",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              1,
              1
            ],
            "angle": [
              1.6,
              2
            ],
            "scantime": [
              0.5,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Scanner_WideAngle",
      "fdName": "Scanner_WideAngle",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Wide Angle Scanner",
      "displayName": "Wake Scanner — Wide Angle Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.2,
              0.2
            ],
            "angle": [
              0,
              0.4
            ],
            "scantime": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.4,
              0.4
            ],
            "angle": [
              0.4,
              0.8
            ],
            "scantime": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.6,
              0.6
            ],
            "angle": [
              0.8,
              1.2
            ],
            "scantime": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "encodedscandata",
              "name": "Divergent Scan Data",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+160%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.8,
              0.8
            ],
            "angle": [
              1.2,
              1.6
            ],
            "scantime": [
              0.4,
              0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "classifiedscandata",
              "name": "Classified Scan Fragment",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Scan Time",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              1,
              1
            ],
            "angle": [
              1.6,
              2
            ],
            "scantime": [
              0.5,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_Expanded",
      "fdName": "Sensor_Expanded",
      "moduleKeys": [
        "ss"
      ],
      "moduleName": "Surface Scanner",
      "name": "Expanded Probe Scanning Radius",
      "displayName": "Surface Scanner — Expanded Probe Scanning Radius",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Probe Radius",
              "effect": "+10%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.2,
              0.2
            ],
            "proberadius": [
              0,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Probe Radius",
              "effect": "+20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.4,
              0.4
            ],
            "proberadius": [
              0.1,
              0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Probe Radius",
              "effect": "+30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.6,
              0.6
            ],
            "proberadius": [
              0.2,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Probe Radius",
              "effect": "+40%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              0.8,
              0.8
            ],
            "proberadius": [
              0.3,
              0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson"
          ],
          "effects": [
            {
              "property": "Probe Radius",
              "effect": "+50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "mass": [
              1,
              1
            ],
            "proberadius": [
              0.4,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_FastScan",
      "fdName": "Sensor_FastScan",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Kill Warrant Scanner",
      "name": "Fast Scanner",
      "displayName": "Kill Warrant Scanner — Fast Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "range": [
              -0.05,
              -0.05
            ],
            "scantime": [
              0,
              -0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "range": [
              -0.1,
              -0.1
            ],
            "scantime": [
              -0.2,
              -0.35
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "opensymmetrickeys",
              "name": "Open Symmetric Keys",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "range": [
              -0.15,
              -0.15
            ],
            "scantime": [
              -0.35,
              -0.5
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "atypicalencryptionarchives",
              "name": "Atypical Encryption Archives",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "scantime": [
              -0.5,
              -0.65
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "adaptiveencryptorscapture",
              "name": "Adaptive Encryptors Capture",
              "size": 1
            },
            {
              "materialKey": "arsenic",
              "name": "Arsenic",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-80%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "range": [
              -0.25,
              -0.25
            ],
            "scantime": [
              -0.8,
              -0.8
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_FastScan",
      "fdName": "Sensor_FastScan",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Manifest Scanner",
      "name": "Fast Scanner",
      "displayName": "Manifest Scanner — Fast Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "range": [
              -0.05,
              -0.05
            ],
            "scantime": [
              0,
              -0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "range": [
              -0.1,
              -0.1
            ],
            "scantime": [
              -0.2,
              -0.35
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "opensymmetrickeys",
              "name": "Open Symmetric Keys",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "range": [
              -0.15,
              -0.15
            ],
            "scantime": [
              -0.35,
              -0.5
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "atypicalencryptionarchives",
              "name": "Atypical Encryption Archives",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "scantime": [
              -0.5,
              -0.65
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "adaptiveencryptorscapture",
              "name": "Adaptive Encryptors Capture",
              "size": 1
            },
            {
              "materialKey": "arsenic",
              "name": "Arsenic",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-80%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "range": [
              -0.25,
              -0.25
            ],
            "scantime": [
              -0.8,
              -0.8
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_FastScan",
      "fdName": "Sensor_FastScan",
      "moduleKeys": [
        "cs",
        "kw",
        "ws"
      ],
      "moduleName": "Wake Scanner",
      "name": "Fast Scanner",
      "displayName": "Wake Scanner — Fast Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "range": [
              -0.05,
              -0.05
            ],
            "scantime": [
              0,
              -0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "range": [
              -0.1,
              -0.1
            ],
            "scantime": [
              -0.2,
              -0.35
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "opensymmetrickeys",
              "name": "Open Symmetric Keys",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            },
            {
              "materialKey": "uncutfocuscrystals",
              "name": "Flawed Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "range": [
              -0.15,
              -0.15
            ],
            "scantime": [
              -0.35,
              -0.5
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "atypicalencryptionarchives",
              "name": "Atypical Encryption Archives",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "scantime": [
              -0.5,
              -0.65
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "adaptiveencryptorscapture",
              "name": "Adaptive Encryptors Capture",
              "size": 1
            },
            {
              "materialKey": "arsenic",
              "name": "Arsenic",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Scan Range",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Scan Time",
              "effect": "-80%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "range": [
              -0.25,
              -0.25
            ],
            "scantime": [
              -0.8,
              -0.8
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_LightWeight",
      "fdName": "Sensor_LightWeight",
      "moduleKeys": [
        "s"
      ],
      "moduleName": "Sensors",
      "name": "Light Weight Scanner",
      "displayName": "Sensors — Light Weight Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              0,
              -0.2
            ],
            "angle": [
              -0.05,
              -0.05
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.2,
              -0.35
            ],
            "angle": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.35,
              -0.5
            ],
            "angle": [
              -0.15,
              -0.15
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-65%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.5,
              -0.65
            ],
            "angle": [
              -0.2,
              -0.2
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-80%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.65,
              -0.8
            ],
            "angle": [
              -0.25,
              -0.25
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_LongRange",
      "fdName": "Sensor_LongRange",
      "moduleKeys": [
        "s"
      ],
      "moduleName": "Sensors",
      "name": "Long Range Scanner",
      "displayName": "Sensors — Long Range Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.2,
              0.2
            ],
            "angle": [
              -0.1,
              -0.1
            ],
            "range": [
              0,
              0.15
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.4,
              0.4
            ],
            "angle": [
              -0.15,
              -0.15
            ],
            "range": [
              0.15,
              0.3
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+45%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.6,
              0.6
            ],
            "angle": [
              -0.2,
              -0.2
            ],
            "range": [
              0.3,
              0.45
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "decodedemissiondata",
              "name": "Decoded Emission Data",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              0.8,
              0.8
            ],
            "angle": [
              -0.25,
              -0.25
            ],
            "range": [
              0.45,
              0.6
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "compactemissionsdata",
              "name": "Abnormal Compact Emission Data",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "mass": [
              1,
              1
            ],
            "angle": [
              -0.3,
              -0.3
            ],
            "range": [
              0.6,
              0.75
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Sensor_WideAngle",
      "fdName": "Sensor_WideAngle",
      "moduleKeys": [
        "s"
      ],
      "moduleName": "Sensors",
      "name": "Wide Angle Scanner",
      "displayName": "Sensors — Wide Angle Scanner",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.1,
              0.1
            ],
            "angle": [
              0,
              0.4
            ],
            "range": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "-8%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.2,
              0.2
            ],
            "angle": [
              0.4,
              0.8
            ],
            "range": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "scandatabanks",
              "name": "Classified Scan Databanks",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Felicity Farseer",
            "Hera Tani",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.3,
              0.3
            ],
            "angle": [
              0.8,
              1.2
            ],
            "range": [
              -0.12,
              -0.12
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "encodedscandata",
              "name": "Divergent Scan Data",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+160%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+40%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "-16%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.4,
              0.4
            ],
            "angle": [
              1.2,
              1.6
            ],
            "range": [
              -0.16,
              -0.16
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "classifiedscandata",
              "name": "Classified Scan Fragment",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Juri Ishmaak",
            "Lei Cheung",
            "Lori Jameson",
            "Tiana Fortune"
          ],
          "effects": [
            {
              "property": "Scan Angle",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+50%",
              "isGood": false
            },
            {
              "property": "Range",
              "effect": "-20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "power": [
              0.5,
              0.5
            ],
            "angle": [
              1.6,
              2
            ],
            "range": [
              -0.2,
              -0.2
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldBooster_Explosive",
      "fdName": "ShieldBooster_Explosive",
      "moduleKeys": [
        "sb"
      ],
      "moduleName": "Shield Booster",
      "name": "Blast Resistant",
      "displayName": "Shield Booster — Blast Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Felicity Farseer",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0,
              0.07
            ],
            "kinres": [
              -0.01,
              -0.01
            ],
            "thermres": [
              -0.01,
              -0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "+12%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.07,
              0.12
            ],
            "kinres": [
              -0.0175,
              -0.0175
            ],
            "thermres": [
              -0.0175,
              -0.0175
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.12,
              0.17
            ],
            "kinres": [
              -0.025,
              -0.025
            ],
            "thermres": [
              -0.025,
              -0.025
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "+22%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.17,
              0.22
            ],
            "kinres": [
              -0.0325,
              -0.0325
            ],
            "thermres": [
              -0.0325,
              -0.0325
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "aberrantshieldpatternanalysis",
              "name": "Aberrant Shield Pattern Analysis",
              "size": 1
            },
            {
              "materialKey": "exquisitefocuscrystals",
              "name": "Exquisite Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "+27%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.22,
              0.27
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldBooster_HeavyDuty",
      "fdName": "ShieldBooster_HeavyDuty",
      "moduleKeys": [
        "sb"
      ],
      "moduleName": "Shield Booster",
      "name": "Heavy Duty",
      "displayName": "Shield Booster — Heavy Duty",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Felicity Farseer",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+5%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Shield Boost",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.03
            ],
            "mass": [
              1,
              1
            ],
            "power": [
              0.05,
              0.05
            ],
            "shieldboost": [
              0.03,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Shield Boost",
              "effect": "+17%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+150%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.03,
              0.06
            ],
            "mass": [
              1.5,
              1.5
            ],
            "power": [
              0.1,
              0.1
            ],
            "shieldboost": [
              0.1,
              0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Shield Boost",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+200%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.06,
              0.09
            ],
            "mass": [
              2,
              2
            ],
            "power": [
              0.15,
              0.15
            ],
            "shieldboost": [
              0.17,
              0.24
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "inconsistentshieldsoakanalysis",
              "name": "Inconsistent Shield Soak Analysis",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Shield Boost",
              "effect": "+31%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+250%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.09,
              0.12
            ],
            "mass": [
              2.5,
              2.5
            ],
            "power": [
              0.2,
              0.2
            ],
            "shieldboost": [
              0.24,
              0.31
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "antimony",
              "name": "Antimony",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Shield Boost",
              "effect": "+38%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+300%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.12,
              0.15
            ],
            "mass": [
              3,
              3
            ],
            "power": [
              0.25,
              0.25
            ],
            "shieldboost": [
              0.31,
              0.38
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldBooster_Kinetic",
      "fdName": "ShieldBooster_Kinetic",
      "moduleKeys": [
        "sb"
      ],
      "moduleName": "Shield Booster",
      "name": "Kinetic Resistant",
      "displayName": "Shield Booster — Kinetic Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Felicity Farseer",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "-1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.01,
              -0.01
            ],
            "kinres": [
              0,
              0.07
            ],
            "thermres": [
              -0.01,
              -0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "-1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.0175,
              -0.0175
            ],
            "kinres": [
              0.07,
              0.12
            ],
            "thermres": [
              -0.0175,
              -0.0175
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+17%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "-2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.025,
              -0.025
            ],
            "kinres": [
              0.12,
              0.17
            ],
            "thermres": [
              -0.025,
              -0.025
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "galvanisingalloys",
              "name": "Galvanising Alloys",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+22%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.0325,
              -0.0325
            ],
            "kinres": [
              0.17,
              0.22
            ],
            "thermres": [
              -0.0325,
              -0.0325
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "aberrantshieldpatternanalysis",
              "name": "Aberrant Shield Pattern Analysis",
              "size": 1
            },
            {
              "materialKey": "exquisitefocuscrystals",
              "name": "Exquisite Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "kinres": [
              0.22,
              0.27
            ],
            "thermres": [
              -0.04,
              -0.04
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldBooster_Resistive",
      "fdName": "ShieldBooster_Resistive",
      "moduleKeys": [
        "sb"
      ],
      "moduleName": "Shield Booster",
      "name": "Resistance Augmented",
      "displayName": "Shield Booster — Resistance Augmented",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Felicity Farseer",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+5%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+5%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.05,
              0.05
            ],
            "integrity": [
              -0.04,
              -0.04
            ],
            "kinres": [
              0.05,
              0.05
            ],
            "power": [
              0.05,
              0.05
            ],
            "thermres": [
              0.05,
              0.05
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.08,
              0.08
            ],
            "integrity": [
              -0.06,
              -0.06
            ],
            "kinres": [
              0.08,
              0.08
            ],
            "power": [
              0.1,
              0.1
            ],
            "thermres": [
              0.08,
              0.08
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+11%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.11,
              0.11
            ],
            "integrity": [
              -0.08,
              -0.08
            ],
            "kinres": [
              0.11,
              0.11
            ],
            "power": [
              0.15,
              0.15
            ],
            "thermres": [
              0.11,
              0.11
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.14,
              0.14
            ],
            "integrity": [
              -0.1,
              -0.1
            ],
            "kinres": [
              0.14,
              0.14
            ],
            "power": [
              0.2,
              0.2
            ],
            "thermres": [
              0.14,
              0.14
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "imperialshielding",
              "name": "Imperial Shielding",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              0.17,
              0.17
            ],
            "integrity": [
              -0.12,
              -0.12
            ],
            "kinres": [
              0.17,
              0.17
            ],
            "power": [
              0.25,
              0.25
            ],
            "thermres": [
              0.17,
              0.17
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldBooster_Thermic",
      "fdName": "ShieldBooster_Thermic",
      "moduleKeys": [
        "sb"
      ],
      "moduleName": "Shield Booster",
      "name": "Thermal Resistant",
      "displayName": "Shield Booster — Thermal Resistant",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Felicity Farseer",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Explosive Resistance",
              "effect": "-1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.01,
              -0.01
            ],
            "kinres": [
              -0.01,
              -0.01
            ],
            "thermres": [
              0,
              0.07
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Explosive Resistance",
              "effect": "-1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.0175,
              -0.0175
            ],
            "kinres": [
              -0.0175,
              -0.0175
            ],
            "thermres": [
              0.07,
              0.12
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "heatconductionwiring",
              "name": "Heat Conduction Wiring",
              "size": 1
            },
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+17%",
              "isGood": true
            },
            {
              "property": "Explosive Resistance",
              "effect": "-2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.025,
              -0.025
            ],
            "kinres": [
              -0.025,
              -0.025
            ],
            "thermres": [
              0.12,
              0.17
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+22%",
              "isGood": true
            },
            {
              "property": "Explosive Resistance",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.0325,
              -0.0325
            ],
            "kinres": [
              -0.0325,
              -0.0325
            ],
            "thermres": [
              0.17,
              0.22
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "aberrantshieldpatternanalysis",
              "name": "Aberrant Shield Pattern Analysis",
              "size": 1
            },
            {
              "materialKey": "exquisitefocuscrystals",
              "name": "Exquisite Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Thermal Resistance",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Explosive Resistance",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "explres": [
              -0.04,
              -0.04
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              0.22,
              0.27
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldCellBank_Rapid",
      "fdName": "ShieldCellBank_Rapid",
      "moduleKeys": [
        "scb"
      ],
      "moduleName": "Shield Cell Bank",
      "name": "Rapid Charge",
      "displayName": "Shield Cell Bank — Rapid Charge",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Duration",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Spin Up Time",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Boot Time",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+5%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              0.1,
              0.1
            ],
            "duration": [
              -0.06,
              -0.06
            ],
            "shieldreinforcement": [
              0,
              0.05
            ],
            "spinup": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "gridresistors",
              "name": "Grid Resistors",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Duration",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Spin Up Time",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Boot Time",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+10%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              0.15,
              0.15
            ],
            "duration": [
              -0.12,
              -0.12
            ],
            "shieldreinforcement": [
              0.05,
              0.1
            ],
            "spinup": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Duration",
              "effect": "-18%",
              "isGood": false
            },
            {
              "property": "Spin Up Time",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Boot Time",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+15%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              0.2,
              0.2
            ],
            "duration": [
              -0.18,
              -0.18
            ],
            "shieldreinforcement": [
              0.1,
              0.15
            ],
            "spinup": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "hybridcapacitors",
              "name": "Hybrid Capacitors",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Duration",
              "effect": "-24%",
              "isGood": false
            },
            {
              "property": "Spin Up Time",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Boot Time",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "boot": [
              0.25,
              0.25
            ],
            "duration": [
              -0.24,
              -0.24
            ],
            "shieldreinforcement": [
              0.15,
              0.2
            ],
            "spinup": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldCellBank_Specialised",
      "fdName": "ShieldCellBank_Specialised",
      "moduleKeys": [
        "scb"
      ],
      "moduleName": "Shield Cell Bank",
      "name": "Specialised",
      "displayName": "Shield Cell Bank — Specialised",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Elvira Martuuk",
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-6%",
              "isGood": true
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+4%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              0,
              -0.08
            ],
            "integrity": [
              -0.05,
              -0.05
            ],
            "power": [
              0.1,
              0.1
            ],
            "shieldreinforcement": [
              0,
              0.04
            ],
            "thermload": [
              0,
              -0.06
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-16%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+6%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.08,
              -0.16
            ],
            "integrity": [
              -0.1,
              -0.1
            ],
            "power": [
              0.15,
              0.15
            ],
            "shieldreinforcement": [
              0.04,
              0.06
            ],
            "thermload": [
              -0.06,
              -0.12
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            }
          ],
          "engineers": [
            "Lori Jameson",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-18%",
              "isGood": true
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "boot": [
              -0.16,
              -0.24
            ],
            "integrity": [
              -0.15,
              -0.15
            ],
            "power": [
              0.2,
              0.2
            ],
            "shieldreinforcement": [
              0.06,
              0.08
            ],
            "thermload": [
              -0.12,
              -0.18
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "yttrium",
              "name": "Yttrium",
              "size": 1
            }
          ],
          "engineers": [
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Boot Time",
              "effect": "-32%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Shield Reinforcement",
              "effect": "+10%",
              "isGood": true
            }
          ],
          "ingredientsSource": "heuristic",
          "modifiers": {
            "boot": [
              -0.24,
              -0.32
            ],
            "integrity": [
              -0.2,
              -0.2
            ],
            "power": [
              0.25,
              0.25
            ],
            "shieldreinforcement": [
              0.08,
              0.1
            ],
            "thermload": [
              -0.18,
              -0.24
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldGenerator_Kinetic",
      "fdName": "ShieldGenerator_Kinetic",
      "moduleKeys": [
        "bsg",
        "psg",
        "sg"
      ],
      "moduleName": "Shield Generator",
      "name": "Kinetic Resistant Shields",
      "displayName": "Shield Generator — Kinetic Resistant Shields",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.2
            ],
            "kinres": [
              0,
              0.1
            ],
            "thermres": [
              -0.03,
              -0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+25%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.2,
              0.25
            ],
            "kinres": [
              0.1,
              0.2
            ],
            "thermres": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.25,
              0.3
            ],
            "kinres": [
              0.2,
              0.3
            ],
            "thermres": [
              -0.09,
              -0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "inconsistentshieldsoakanalysis",
              "name": "Inconsistent Shield Soak Analysis",
              "size": 1
            },
            {
              "materialKey": "mercury",
              "name": "Mercury",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+35%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.3,
              0.35
            ],
            "kinres": [
              0.3,
              0.4
            ],
            "thermres": [
              -0.12,
              -0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "ruthenium",
              "name": "Ruthenium",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.35,
              0.4
            ],
            "kinres": [
              0.4,
              0.5
            ],
            "thermres": [
              -0.15,
              -0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldGenerator_Optimised",
      "fdName": "ShieldGenerator_Optimised",
      "moduleKeys": [
        "bsg",
        "psg",
        "sg"
      ],
      "moduleName": "Shield Generator",
      "name": "Enhanced, Low Power Shields",
      "displayName": "Shield Generator — Enhanced, Low Power Shields",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Optimal Strength",
              "effect": "+3%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-18%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.05,
              -0.05
            ],
            "mass": [
              0,
              -0.18
            ],
            "optmass": [
              -0.02,
              -0.02
            ],
            "optmul": [
              0,
              0.03
            ],
            "power": [
              0,
              -0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Optimal Strength",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.1,
              -0.1
            ],
            "mass": [
              -0.18,
              -0.26
            ],
            "optmass": [
              -0.03,
              -0.03
            ],
            "optmul": [
              0.03,
              0.06
            ],
            "power": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Optimal Strength",
              "effect": "+9%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-34%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.15,
              -0.15
            ],
            "mass": [
              -0.26,
              -0.34
            ],
            "optmass": [
              -0.04,
              -0.04
            ],
            "optmul": [
              0.06,
              0.09
            ],
            "power": [
              -0.25,
              -0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "inconsistentshieldsoakanalysis",
              "name": "Inconsistent Shield Soak Analysis",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Optimal Strength",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-42%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              -0.34,
              -0.42
            ],
            "optmass": [
              -0.05,
              -0.05
            ],
            "optmul": [
              0.09,
              0.12
            ],
            "power": [
              -0.3,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "militarygradealloys",
              "name": "Military Grade Alloys",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Optimal Strength",
              "effect": "+15%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-25%",
              "isGood": false
            },
            {
              "property": "Optimal Mass",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.25,
              -0.25
            ],
            "mass": [
              -0.42,
              -0.5
            ],
            "optmass": [
              -0.06,
              -0.06
            ],
            "optmul": [
              0.12,
              0.15
            ],
            "power": [
              -0.35,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldGenerator_Reinforced",
      "fdName": "ShieldGenerator_Reinforced",
      "moduleKeys": [
        "bsg",
        "psg",
        "sg"
      ],
      "moduleName": "Shield Generator",
      "name": "Reinforced Shields",
      "displayName": "Shield Generator — Reinforced Shields",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Distributor Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Optimal Strength",
              "effect": "+14%",
              "isGood": true
            },
            {
              "property": "Broken Regen Rate",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+5%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "brokenregen": [
              -0.1,
              -0.1
            ],
            "distdraw": [
              0.04,
              0.04
            ],
            "explres": [
              0,
              0.045
            ],
            "kinres": [
              0,
              0.045
            ],
            "optmul": [
              0,
              0.14
            ],
            "thermres": [
              0,
              0.045
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Distributor Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Optimal Strength",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Broken Regen Rate",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "brokenregen": [
              -0.1,
              -0.1
            ],
            "distdraw": [
              0.06,
              0.06
            ],
            "explres": [
              0.045,
              0.075
            ],
            "kinres": [
              0.045,
              0.075
            ],
            "optmul": [
              0.14,
              0.2
            ],
            "thermres": [
              0.045,
              0.075
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Distributor Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Optimal Strength",
              "effect": "+26%",
              "isGood": true
            },
            {
              "property": "Broken Regen Rate",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+11%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "brokenregen": [
              -0.1,
              -0.1
            ],
            "distdraw": [
              0.08,
              0.08
            ],
            "explres": [
              0.075,
              0.105
            ],
            "kinres": [
              0.075,
              0.105
            ],
            "optmul": [
              0.2,
              0.26
            ],
            "thermres": [
              0.075,
              0.105
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Distributor Draw",
              "effect": "+10%",
              "isGood": false
            },
            {
              "property": "Optimal Strength",
              "effect": "+32%",
              "isGood": true
            },
            {
              "property": "Broken Regen Rate",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+14%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-7%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "brokenregen": [
              -0.1,
              -0.1
            ],
            "distdraw": [
              0.1,
              0.1
            ],
            "explres": [
              0.105,
              0.135
            ],
            "kinres": [
              0.105,
              0.135
            ],
            "optmul": [
              0.26,
              0.32
            ],
            "thermres": [
              0.105,
              0.135
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "arsenic",
              "name": "Arsenic",
              "size": 1
            },
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "improvisedcomponents",
              "name": "Improvised Components",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Distributor Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Optimal Strength",
              "effect": "+38%",
              "isGood": true
            },
            {
              "property": "Broken Regen Rate",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "All Resistances",
              "effect": "+17%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "-9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "brokenregen": [
              -0.1,
              -0.1
            ],
            "distdraw": [
              0.12,
              0.12
            ],
            "explres": [
              0.135,
              0.165
            ],
            "kinres": [
              0.135,
              0.165
            ],
            "optmul": [
              0.32,
              0.38
            ],
            "thermres": [
              0.135,
              0.165
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "ShieldGenerator_Thermic",
      "fdName": "ShieldGenerator_Thermic",
      "moduleKeys": [
        "bsg",
        "psg",
        "sg"
      ],
      "moduleName": "Shield Generator",
      "name": "Thermal Resistant Shields",
      "displayName": "Shield Generator — Thermal Resistant Shields",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "+10%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              0.2
            ],
            "kinres": [
              -0.04,
              -0.04
            ],
            "thermres": [
              0,
              0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+25%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "+20%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.2,
              0.25
            ],
            "kinres": [
              -0.08,
              -0.08
            ],
            "thermres": [
              0.1,
              0.2
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "distortedshieldcyclerecordings",
              "name": "Distorted Shield Cycle Recordings",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Didi Vatermann",
            "Elvira Martuuk",
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "+30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.25,
              0.3
            ],
            "kinres": [
              -0.12,
              -0.12
            ],
            "thermres": [
              0.2,
              0.3
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "inconsistentshieldsoakanalysis",
              "name": "Inconsistent Shield Soak Analysis",
              "size": 1
            },
            {
              "materialKey": "mercury",
              "name": "Mercury",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-16%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+35%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "+40%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.3,
              0.35
            ],
            "kinres": [
              -0.16,
              -0.16
            ],
            "thermres": [
              0.3,
              0.4
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "ruthenium",
              "name": "Ruthenium",
              "size": 1
            },
            {
              "materialKey": "shielddensityreports",
              "name": "Untypical Shield Scans",
              "size": 1
            }
          ],
          "engineers": [
            "Lei Cheung",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Kinetic Resistance",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Integrity",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Resistance",
              "effect": "+50%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0.35,
              0.4
            ],
            "kinres": [
              -0.2,
              -0.2
            ],
            "thermres": [
              0.4,
              0.5
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_DoubleShot",
      "fdName": "Weapon_DoubleShot",
      "moduleKeys": [
        "fc"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Double Shot",
      "displayName": "Fragment Cannon — Double Shot",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Burst Rate of Fire",
              "effect": "+600%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Burst Size",
              "effect": "2",
              "isGood": true
            },
            {
              "property": "Clip Size",
              "effect": "4",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "burst": [
              2,
              2
            ],
            "burstrof": [
              0,
              6
            ],
            "clip": [
              0.34,
              0.34
            ],
            "range": [
              -0.02,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Burst Rate of Fire",
              "effect": "+800%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Burst Size",
              "effect": "2",
              "isGood": true
            },
            {
              "property": "Clip Size",
              "effect": "4",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "burst": [
              2,
              2
            ],
            "burstrof": [
              6,
              8
            ],
            "clip": [
              0.34,
              0.34
            ],
            "range": [
              -0.04,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "carbon",
              "name": "Carbon",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Burst Rate of Fire",
              "effect": "+1000%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Burst Size",
              "effect": "2",
              "isGood": true
            },
            {
              "property": "Clip Size",
              "effect": "4",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "burst": [
              2,
              2
            ],
            "burstrof": [
              8,
              10
            ],
            "clip": [
              0.34,
              0.34
            ],
            "range": [
              -0.06,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "securityfirmwarepatch",
              "name": "Security Firmware Patch",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Burst Rate of Fire",
              "effect": "+1200%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-8%",
              "isGood": false
            },
            {
              "property": "Burst Size",
              "effect": "2",
              "isGood": true
            },
            {
              "property": "Clip Size",
              "effect": "4",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "burst": [
              2,
              2
            ],
            "burstrof": [
              10,
              12
            ],
            "clip": [
              0.34,
              0.34
            ],
            "range": [
              -0.08,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Burst Rate of Fire",
              "effect": "+1400%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            },
            {
              "property": "Burst Size",
              "effect": "2",
              "isGood": true
            },
            {
              "property": "Clip Size",
              "effect": "6",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "burst": [
              2,
              2
            ],
            "burstrof": [
              12,
              14
            ],
            "clip": [
              1,
              1
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--beam-laser",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Efficient Weapon",
      "displayName": "Beam Laser — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--burst-laser",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Efficient Weapon",
      "displayName": "Burst Laser — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--cannon",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Efficient Weapon",
      "displayName": "Cannon — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--fragment-cannon",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Efficient Weapon",
      "displayName": "Fragment Cannon — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--multi-cannon",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Efficient Weapon",
      "displayName": "Multi-cannon — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--plasma-accelerator",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Efficient Weapon",
      "displayName": "Plasma Accelerator — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Efficient--pulse-laser",
      "fdName": "Weapon_Efficient",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Efficient Weapon",
      "displayName": "Pulse Laser — Efficient Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-38%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.08
            ],
            "thermload": [
              0,
              -0.38
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+12%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-12%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-43%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.08,
              0.12
            ],
            "distdraw": [
              0,
              -0.15
            ],
            "power": [
              0,
              -0.12
            ],
            "thermload": [
              -0.38,
              -0.43
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "exceptionalscrambledemissiondata",
              "name": "Exceptional Scrambled Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatexchangers",
              "name": "Heat Exchangers",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+16%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-24%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-48%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.12,
              0.16
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "power": [
              -0.12,
              -0.24
            ],
            "thermload": [
              -0.43,
              -0.48
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "archivedemissiondata",
              "name": "Irregular Emission Data",
              "size": 1
            },
            {
              "materialKey": "heatvanes",
              "name": "Heat Vanes",
              "size": 1
            },
            {
              "materialKey": "selenium",
              "name": "Selenium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-36%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-53%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.16,
              0.2
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "power": [
              -0.24,
              -0.36
            ],
            "thermload": [
              -0.48,
              -0.52
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "cadmium",
              "name": "Cadmium",
              "size": 1
            },
            {
              "materialKey": "emissiondata",
              "name": "Unexpected Emission Data",
              "size": 1
            },
            {
              "materialKey": "protoheatradiators",
              "name": "Proto Heat Radiators",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+24%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "-48%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.2,
              0.24
            ],
            "distdraw": [
              -0.35,
              -0.45
            ],
            "power": [
              -0.36,
              -0.48
            ],
            "thermload": [
              -0.52,
              -0.6
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Focused--burst-laser",
      "fdName": "Weapon_Focused",
      "moduleKeys": [
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Focused Weapon",
      "displayName": "Burst Laser — Focused Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0,
              0.36
            ],
            "piercing": [
              0,
              0.4
            ],
            "range": [
              0,
              0.36
            ],
            "shotspeed": [
              0,
              0.36
            ],
            "thermload": [
              0.01,
              0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.36,
              0.52
            ],
            "piercing": [
              0.4,
              0.6
            ],
            "range": [
              0.36,
              0.52
            ],
            "shotspeed": [
              0.36,
              0.52
            ],
            "thermload": [
              0.02,
              0.02
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.52,
              0.68
            ],
            "piercing": [
              0.6,
              0.8
            ],
            "range": [
              0.52,
              0.68
            ],
            "shotspeed": [
              0.52,
              0.68
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.68,
              0.84
            ],
            "piercing": [
              0.8,
              1
            ],
            "range": [
              0.68,
              0.84
            ],
            "shotspeed": [
              0.68,
              0.84
            ],
            "thermload": [
              0.04,
              0.04
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+5%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.84,
              1
            ],
            "piercing": [
              1,
              1.2
            ],
            "range": [
              0.84,
              1
            ],
            "shotspeed": [
              0.84,
              1
            ],
            "thermload": [
              0.05,
              0.05
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Focused--plasma-accelerator",
      "fdName": "Weapon_Focused",
      "moduleKeys": [
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Focused Weapon",
      "displayName": "Plasma Accelerator — Focused Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0,
              0.36
            ],
            "piercing": [
              0,
              0.4
            ],
            "range": [
              0,
              0.36
            ],
            "shotspeed": [
              0,
              0.36
            ],
            "thermload": [
              0.01,
              0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.36,
              0.52
            ],
            "piercing": [
              0.4,
              0.6
            ],
            "range": [
              0.36,
              0.52
            ],
            "shotspeed": [
              0.36,
              0.52
            ],
            "thermload": [
              0.02,
              0.02
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.52,
              0.68
            ],
            "piercing": [
              0.6,
              0.8
            ],
            "range": [
              0.52,
              0.68
            ],
            "shotspeed": [
              0.52,
              0.68
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.68,
              0.84
            ],
            "piercing": [
              0.8,
              1
            ],
            "range": [
              0.68,
              0.84
            ],
            "shotspeed": [
              0.68,
              0.84
            ],
            "thermload": [
              0.04,
              0.04
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+5%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.84,
              1
            ],
            "piercing": [
              1,
              1.2
            ],
            "range": [
              0.84,
              1
            ],
            "shotspeed": [
              0.84,
              1
            ],
            "thermload": [
              0.05,
              0.05
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Focused--pulse-laser",
      "fdName": "Weapon_Focused",
      "moduleKeys": [
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Focused Weapon",
      "displayName": "Pulse Laser — Focused Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+1%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0,
              0.36
            ],
            "piercing": [
              0,
              0.4
            ],
            "range": [
              0,
              0.36
            ],
            "shotspeed": [
              0,
              0.36
            ],
            "thermload": [
              0.01,
              0.01
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+2%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.36,
              0.52
            ],
            "piercing": [
              0.4,
              0.6
            ],
            "range": [
              0.36,
              0.52
            ],
            "shotspeed": [
              0.36,
              0.52
            ],
            "thermload": [
              0.02,
              0.02
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "chromium",
              "name": "Chromium",
              "size": 1
            },
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "iron",
              "name": "Iron",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.52,
              0.68
            ],
            "piercing": [
              0.6,
              0.8
            ],
            "range": [
              0.52,
              0.68
            ],
            "shotspeed": [
              0.52,
              0.68
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "germanium",
              "name": "Germanium",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+4%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.68,
              0.84
            ],
            "piercing": [
              0.8,
              1
            ],
            "range": [
              0.68,
              0.84
            ],
            "shotspeed": [
              0.68,
              0.84
            ],
            "thermload": [
              0.04,
              0.04
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "refinedfocuscrystals",
              "name": "Refined Focus Crystals",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+120%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "+5%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "falloff": [
              0.84,
              1
            ],
            "piercing": [
              1,
              1.2
            ],
            "range": [
              0.84,
              1
            ],
            "shotspeed": [
              0.84,
              1
            ],
            "thermload": [
              0.05,
              0.05
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--cannon",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Cannon",
      "name": "High Capacity Magazine",
      "displayName": "Cannon — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--fragment-cannon",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Fragment Cannon",
      "name": "High Capacity Magazine",
      "displayName": "Fragment Cannon — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--mine-launcher",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Mine Launcher",
      "name": "High Capacity Magazine",
      "displayName": "Mine Launcher — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--missile-rack",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Missile Rack",
      "name": "High Capacity Magazine",
      "displayName": "Missile Rack — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--multi-cannon",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Multi-cannon",
      "name": "High Capacity Magazine",
      "displayName": "Multi-cannon — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_HighCapacity--rail-gun",
      "fdName": "Weapon_HighCapacity",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "rg"
      ],
      "moduleName": "Rail Gun",
      "name": "High Capacity Magazine",
      "displayName": "Rail Gun — High Capacity Magazine",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+4%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+36%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+2%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0,
              0.36
            ],
            "clip": [
              0,
              0.36
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.04,
              0.04
            ],
            "rof": [
              0,
              -0.02
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+8%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+52%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+4%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.36,
              0.52
            ],
            "clip": [
              0.36,
              0.52
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.08,
              0.08
            ],
            "rof": [
              -0.02,
              -0.04
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            },
            {
              "materialKey": "niobium",
              "name": "Niobium",
              "size": 1
            },
            {
              "materialKey": "vanadium",
              "name": "Vanadium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+68%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+6%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.52,
              0.68
            ],
            "clip": [
              0.52,
              0.68
            ],
            "mass": [
              0.4,
              0.4
            ],
            "power": [
              0.12,
              0.12
            ],
            "rof": [
              -0.04,
              -0.06
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "tin",
              "name": "Tin",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+16%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+84%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+50%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.68,
              0.84
            ],
            "clip": [
              0.68,
              0.84
            ],
            "mass": [
              0.5,
              0.5
            ],
            "power": [
              0.16,
              0.16
            ],
            "rof": [
              -0.06,
              -0.08
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "fedproprietarycomposites",
              "name": "Proprietary Composites",
              "size": 1
            },
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "militarysupercapacitors",
              "name": "Military Supercapacitors",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Power Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Ammo Capacity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Rate of Fire",
              "effect": "+10%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "ammo": [
              0.84,
              1
            ],
            "clip": [
              0.84,
              1
            ],
            "mass": [
              0.6,
              0.6
            ],
            "power": [
              0.2,
              0.2
            ],
            "rof": [
              -0.08,
              -0.1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--beam-laser",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Lightweight Mount",
      "displayName": "Beam Laser — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--burst-laser",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Lightweight Mount",
      "displayName": "Burst Laser — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--cannon",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Lightweight Mount",
      "displayName": "Cannon — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--fragment-cannon",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Lightweight Mount",
      "displayName": "Fragment Cannon — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--mine-launcher",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Mine Launcher",
      "name": "Lightweight Mount",
      "displayName": "Mine Launcher — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--missile-rack",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Missile Rack",
      "name": "Lightweight Mount",
      "displayName": "Missile Rack — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--multi-cannon",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Lightweight Mount",
      "displayName": "Multi-cannon — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--plasma-accelerator",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Lightweight Mount",
      "displayName": "Plasma Accelerator — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--pulse-laser",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Lightweight Mount",
      "displayName": "Pulse Laser — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--rail-gun",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Rail Gun",
      "name": "Lightweight Mount",
      "displayName": "Rail Gun — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LightWeight--torpedo-pylon",
      "fdName": "Weapon_LightWeight",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Torpedo Pylon",
      "name": "Lightweight Mount",
      "displayName": "Torpedo Pylon — Lightweight Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "phosphorus",
              "name": "Phosphorus",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Mass",
              "effect": "-30%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              -0.2,
              -0.2
            ],
            "mass": [
              0,
              -0.3
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-45%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              0,
              -0.2
            ],
            "integrity": [
              -0.3,
              -0.3
            ],
            "mass": [
              -0.3,
              -0.45
            ],
            "power": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "manganese",
              "name": "Manganese",
              "size": 1
            },
            {
              "materialKey": "salvagedalloys",
              "name": "Salvaged Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-60%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.2,
              -0.25
            ],
            "integrity": [
              -0.4,
              -0.4
            ],
            "mass": [
              -0.45,
              -0.6
            ],
            "power": [
              -0.1,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "phasealloys",
              "name": "Phase Alloys",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-75%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.25,
              -0.3
            ],
            "integrity": [
              -0.5,
              -0.5
            ],
            "mass": [
              -0.6,
              -0.75
            ],
            "power": [
              -0.2,
              -0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "protolightalloys",
              "name": "Proto Light Alloys",
              "size": 1
            },
            {
              "materialKey": "protoradiolicalloys",
              "name": "Proto Radiolic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "-40%",
              "isGood": true
            },
            {
              "property": "Integrity",
              "effect": "-60%",
              "isGood": false
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "-90%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "distdraw": [
              -0.3,
              -0.35
            ],
            "integrity": [
              -0.6,
              -0.6
            ],
            "mass": [
              -0.75,
              -0.9
            ],
            "power": [
              -0.3,
              -0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--beam-laser",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Long Range Weapon",
      "displayName": "Beam Laser — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--burst-laser",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Long Range Weapon",
      "displayName": "Burst Laser — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--cannon",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Long Range Weapon",
      "displayName": "Cannon — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--multi-cannon",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Long Range Weapon",
      "displayName": "Multi-cannon — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--plasma-accelerator",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Long Range Weapon",
      "displayName": "Plasma Accelerator — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Shot Speed",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--pulse-laser",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Long Range Weapon",
      "displayName": "Pulse Laser — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_LongRange--rail-gun",
      "fdName": "Weapon_LongRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Rail Gun",
      "name": "Long Range Weapon",
      "displayName": "Rail Gun — Long Range Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+3%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.2
            ],
            "mass": [
              0.1,
              0.1
            ],
            "power": [
              0.03,
              0.03
            ],
            "range": [
              0,
              0.2
            ],
            "shotspeed": [
              0,
              0.2
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+6%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.2,
              0.4
            ],
            "mass": [
              0.15,
              0.15
            ],
            "power": [
              0.06,
              0.06
            ],
            "range": [
              0.2,
              0.4
            ],
            "shotspeed": [
              0.2,
              0.4
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "sulphur",
              "name": "Sulphur",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+9%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.4,
              0.6
            ],
            "mass": [
              0.2,
              0.2
            ],
            "power": [
              0.09,
              0.09
            ],
            "range": [
              0.4,
              0.6
            ],
            "shotspeed": [
              0.4,
              0.6
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "focuscrystals",
              "name": "Focus Crystals",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+12%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+80%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+25%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.6,
              0.8
            ],
            "mass": [
              0.25,
              0.25
            ],
            "power": [
              0.12,
              0.12
            ],
            "range": [
              0.6,
              0.8
            ],
            "shotspeed": [
              0.6,
              0.8
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Power Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Maximum Range",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Damage Falloff Start",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "fallofffromrange": [
              0.8,
              1
            ],
            "mass": [
              0.3,
              0.3
            ],
            "power": [
              0.15,
              0.15
            ],
            "range": [
              0.8,
              1
            ],
            "shotspeed": [
              0.8,
              1
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--beam-laser",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Overcharged Weapon",
      "displayName": "Beam Laser — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--burst-laser",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Overcharged Weapon",
      "displayName": "Burst Laser — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--cannon",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Overcharged Weapon",
      "displayName": "Cannon — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--fragment-cannon",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Overcharged Weapon",
      "displayName": "Fragment Cannon — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--multi-cannon",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Overcharged Weapon",
      "displayName": "Multi-cannon — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "-6%",
              "isGood": false
            },
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "-9%",
              "isGood": false
            },
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "-12%",
              "isGood": false
            },
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Clip Size",
              "effect": "-15%",
              "isGood": false
            },
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--plasma-accelerator",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Overcharged Weapon",
      "displayName": "Plasma Accelerator — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Overcharged--pulse-laser",
      "fdName": "Weapon_Overcharged",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Overcharged Weapon",
      "displayName": "Pulse Laser — Overcharged Weapon",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+15%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+3%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0,
              0.3
            ],
            "distdraw": [
              0.15,
              0.15
            ],
            "thermload": [
              0.03,
              0.03
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+6%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.3,
              0.4
            ],
            "distdraw": [
              0.2,
              0.2
            ],
            "thermload": [
              0.06,
              0.06
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "conductivecomponents",
              "name": "Conductive Components",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+25%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+9%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.4,
              0.5
            ],
            "distdraw": [
              0.25,
              0.25
            ],
            "thermload": [
              0.09,
              0.09
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductiveceramics",
              "name": "Conductive Ceramics",
              "size": 1
            },
            {
              "materialKey": "polymercapacitors",
              "name": "Polymer Capacitors",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+12%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.5,
              0.6
            ],
            "distdraw": [
              0.3,
              0.3
            ],
            "thermload": [
              0.12,
              0.12
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "modifiedembeddedfirmware",
              "name": "Modified Embedded Firmware",
              "size": 1
            },
            {
              "materialKey": "zirconium",
              "name": "Zirconium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+70%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "+35%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+15%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.6,
              0.7
            ],
            "distdraw": [
              0.35,
              0.35
            ],
            "thermload": [
              0.15,
              0.15
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--burst-laser",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Rapid Fire Modification",
      "displayName": "Burst Laser — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--cannon",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Rapid Fire Modification",
      "displayName": "Cannon — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--fragment-cannon",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Rapid Fire Modification",
      "displayName": "Fragment Cannon — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--mine-launcher",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Mine Launcher",
      "name": "Rapid Fire Modification",
      "displayName": "Mine Launcher — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--missile-rack",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Missile Rack",
      "name": "Rapid Fire Modification",
      "displayName": "Missile Rack — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--multi-cannon",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Rapid Fire Modification",
      "displayName": "Multi-cannon — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--plasma-accelerator",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Rapid Fire Modification",
      "displayName": "Plasma Accelerator — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_RapidFire--pulse-laser",
      "fdName": "Weapon_RapidFire",
      "moduleKeys": [
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Rapid Fire Modification",
      "displayName": "Pulse Laser — Rapid Fire Modification",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-1%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+8%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.01,
              -0.01
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              0,
              -0.25
            ],
            "rof": [
              0,
              -0.08
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "heatdispersionplate",
              "name": "Heat Dispersion Plate",
              "size": 1
            },
            {
              "materialKey": "mechanicalscrap",
              "name": "Mechanical Scrap",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-2%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-5%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+17%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.02,
              -0.02
            ],
            "distdraw": [
              0,
              -0.05
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.25,
              -0.35
            ],
            "rof": [
              -0.08,
              -0.17
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "mechanicalequipment",
              "name": "Mechanical Equipment",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "specialisedlegacyfirmware",
              "name": "Specialised Legacy Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-3%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-45%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+26%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.03,
              -0.03
            ],
            "distdraw": [
              -0.05,
              -0.15
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.35,
              -0.45
            ],
            "rof": [
              -0.17,
              -0.26
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "mechanicalcomponents",
              "name": "Mechanical Components",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "thermicalloys",
              "name": "Thermic Alloys",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-4%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-56%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+35%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.04,
              -0.04
            ],
            "distdraw": [
              -0.15,
              -0.25
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.45,
              -0.55
            ],
            "rof": [
              -0.26,
              -0.35
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "precipitatedalloys",
              "name": "Precipitated Alloys",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "-5%",
              "isGood": false
            },
            {
              "property": "Reload Time",
              "effect": "-65%",
              "isGood": true
            },
            {
              "property": "Distributor Draw",
              "effect": "-35%",
              "isGood": true
            },
            {
              "property": "Jitter",
              "effect": "0,5",
              "isGood": false
            },
            {
              "property": "Rate of Fire",
              "effect": "+44%",
              "isGood": true
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              -0.05,
              -0.05
            ],
            "distdraw": [
              -0.25,
              -0.35
            ],
            "jitter": [
              0.5,
              0.5
            ],
            "reload": [
              -0.55,
              -0.65
            ],
            "rof": [
              -0.35,
              -0.44
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--beam-laser",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Short Range Blaster",
      "displayName": "Beam Laser — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--burst-laser",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Short Range Blaster",
      "displayName": "Burst Laser — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--cannon",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Short Range Blaster",
      "displayName": "Cannon — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--multi-cannon",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Short Range Blaster",
      "displayName": "Multi-cannon — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--plasma-accelerator",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Short Range Blaster",
      "displayName": "Plasma Accelerator — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_ShortRange--rail-gun",
      "fdName": "Weapon_ShortRange",
      "moduleKeys": [
        "bl",
        "c",
        "mc",
        "advmc",
        "pa",
        "pl",
        "rg",
        "ul"
      ],
      "moduleName": "Rail Gun",
      "name": "Short Range Blaster",
      "displayName": "Rail Gun — Short Range Blaster",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+27%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.15,
              0.27
            ],
            "range": [
              -0.1,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+39%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-20%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+10%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.27,
              0.39
            ],
            "range": [
              -0.2,
              -0.2
            ],
            "thermload": [
              0.1,
              0.1
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            },
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+51%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-30%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.39,
              0.51
            ],
            "range": [
              -0.3,
              -0.3
            ],
            "thermload": [
              0.2,
              0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "conductivepolymers",
              "name": "Conductive Polymers",
              "size": 1
            },
            {
              "materialKey": "electrochemicalarrays",
              "name": "Electrochemical Arrays",
              "size": 1
            },
            {
              "materialKey": "modifiedconsumerfirmware",
              "name": "Modified Consumer Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+63%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-40%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+30%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.51,
              0.63
            ],
            "range": [
              -0.4,
              -0.4
            ],
            "thermload": [
              0.3,
              0.3
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "biotechconductors",
              "name": "Biotech Conductors",
              "size": 1
            },
            {
              "materialKey": "configurablecomponents",
              "name": "Configurable Components",
              "size": 1
            },
            {
              "materialKey": "crackedindustrialfirmware",
              "name": "Cracked Industrial Firmware",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Damage",
              "effect": "+75%",
              "isGood": true
            },
            {
              "property": "Maximum Range",
              "effect": "-50%",
              "isGood": false
            },
            {
              "property": "Thermal Load",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "damage": [
              0.63,
              0.75
            ],
            "range": [
              -0.5,
              -0.5
            ],
            "thermload": [
              0.4,
              0.4
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--beam-laser",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Beam Laser",
      "name": "Sturdy Mount",
      "displayName": "Beam Laser — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--burst-laser",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Burst Laser",
      "name": "Sturdy Mount",
      "displayName": "Burst Laser — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--cannon",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Cannon",
      "name": "Sturdy Mount",
      "displayName": "Cannon — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "The Sarge"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--fragment-cannon",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Fragment Cannon",
      "name": "Sturdy Mount",
      "displayName": "Fragment Cannon — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--mine-launcher",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Mine Launcher",
      "name": "Sturdy Mount",
      "displayName": "Mine Launcher — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--missile-rack",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Missile Rack",
      "name": "Sturdy Mount",
      "displayName": "Missile Rack — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--multi-cannon",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Multi-cannon",
      "name": "Sturdy Mount",
      "displayName": "Multi-cannon — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Marsha Hicks",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--plasma-accelerator",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Plasma Accelerator",
      "name": "Sturdy Mount",
      "displayName": "Plasma Accelerator — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn",
            "Zacariah Nemo"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Bill Turner",
            "Etienne Dorn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--pulse-laser",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Pulse Laser",
      "name": "Sturdy Mount",
      "displayName": "Pulse Laser — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon",
            "The Dweller"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Broo Tarquin",
            "Mel Brandon"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--rail-gun",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Rail Gun",
      "name": "Sturdy Mount",
      "displayName": "Rail Gun — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "The Sarge",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Etienne Dorn",
            "Tod 'The Blaster' McQuinn"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    },
    {
      "key": "Weapon_Sturdy--torpedo-pylon",
      "fdName": "Weapon_Sturdy",
      "moduleKeys": [
        "bl",
        "c",
        "fc",
        "mc",
        "advmc",
        "mr",
        "amr",
        "nl",
        "pa",
        "pl",
        "rg",
        "tp",
        "ul"
      ],
      "moduleName": "Torpedo Pylon",
      "name": "Sturdy Mount",
      "displayName": "Torpedo Pylon — Sturdy Mount",
      "grades": [
        {
          "grade": 1,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+100%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-10%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+20%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+20%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              0,
              1
            ],
            "mass": [
              0.2,
              0.2
            ],
            "piercing": [
              0,
              0.2
            ],
            "thermload": [
              0,
              -0.1
            ]
          }
        },
        {
          "grade": 2,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+150%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-15%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+30%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+40%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              1.5,
              1.5
            ],
            "mass": [
              0.4,
              0.4
            ],
            "piercing": [
              0.2,
              0.3
            ],
            "thermload": [
              -0.1,
              -0.15
            ]
          }
        },
        {
          "grade": 3,
          "ingredients": [
            {
              "materialKey": "nickel",
              "name": "Nickel",
              "size": 1
            },
            {
              "materialKey": "shieldemitters",
              "name": "Shield Emitters",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            }
          ],
          "engineers": [
            "Juri Ishmaak",
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+200%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-20%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+40%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+60%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2,
              2
            ],
            "mass": [
              0.6,
              0.6
            ],
            "piercing": [
              0.3,
              0.4
            ],
            "thermload": [
              -0.15,
              -0.2
            ]
          }
        },
        {
          "grade": 4,
          "ingredients": [
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "tungsten",
              "name": "Tungsten",
              "size": 1
            },
            {
              "materialKey": "zinc",
              "name": "Zinc",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+250%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-25%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+50%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+80%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              2.5,
              2.5
            ],
            "mass": [
              0.8,
              0.8
            ],
            "piercing": [
              0.4,
              0.5
            ],
            "thermload": [
              -0.2,
              -0.25
            ]
          }
        },
        {
          "grade": 5,
          "ingredients": [
            {
              "materialKey": "highdensitycomposites",
              "name": "High Density Composites",
              "size": 1
            },
            {
              "materialKey": "molybdenum",
              "name": "Molybdenum",
              "size": 1
            },
            {
              "materialKey": "technetium",
              "name": "Technetium",
              "size": 1
            }
          ],
          "engineers": [
            "Liz Ryder",
            "Petra Olmanova"
          ],
          "effects": [
            {
              "property": "Integrity",
              "effect": "+300%",
              "isGood": true
            },
            {
              "property": "Thermal Load",
              "effect": "-30%",
              "isGood": true
            },
            {
              "property": "Armour Piercing",
              "effect": "+60%",
              "isGood": true
            },
            {
              "property": "Mass",
              "effect": "+100%",
              "isGood": false
            }
          ],
          "ingredientsSource": "uuid",
          "modifiers": {
            "integrity": [
              3,
              3
            ],
            "mass": [
              1,
              1
            ],
            "piercing": [
              0.5,
              0.6
            ],
            "thermload": [
              -0.25,
              -0.3
            ]
          }
        }
      ],
      "dataStatus": "verified"
    }
  ]
}
